var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicBandContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5310_24142)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 362,
    width: 306,
    height: 438,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.636 2C137.636 1.44772 137.189 1 136.636 1H129.364C128.811 1 128.364 1.44771 128.364 2V15.7143C128.364 16.2666 127.916 16.7143 127.364 16.7143H117C116.448 16.7143 116 17.162 116 17.7143V44C116 44.5523 116.448 45 117 45H121.182C121.734 45 122.182 44.5523 122.182 44V24C122.182 23.4477 122.63 23 123.182 23H142.818C143.37 23 143.818 23.4477 143.818 24V44C143.818 44.5523 144.266 45 144.818 45H149C149.552 45 150 44.5523 150 44V17.7143C150 17.162 149.552 16.7143 149 16.7143H138.636C138.084 16.7143 137.636 16.2666 137.636 15.7143V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.293 77.5408L127.534 77.347L127.468 77.0442L119.925 42.4536C118.068 33.9364 122.941 25.3914 131.217 22.6527C139.493 19.9139 148.501 23.8654 152.091 31.8092L166.671 64.071L166.799 64.3535L167.108 64.3648C169.467 64.4512 171.632 65.9794 172.416 68.3502L175.392 77.3418C178.044 85.3562 173.697 94.0032 165.682 96.6554L147.699 102.606C139.685 105.259 131.038 100.912 128.386 92.8973L125.41 83.9056C124.625 81.5348 125.451 79.0172 127.293 77.5408Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.377,
    cy: 89.616,
    rx: 18.9424,
    ry: 7.89267,
    transform: "rotate(-18.3106 153.377 89.616)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253,
    cy: 359.5,
    rx: 153,
    ry: 37.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841,
    y: 293,
    width: 259,
    height: 504,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.91 2C1066.91 1.44772 1067.36 1 1067.91 1H1075.19C1075.74 1 1076.19 1.44771 1076.19 2V15.7143C1076.19 16.2666 1076.63 16.7143 1077.19 16.7143H1087.55C1088.1 16.7143 1088.55 17.162 1088.55 17.7143V44C1088.55 44.5523 1088.1 45 1087.55 45H1083.37C1082.82 45 1082.37 44.5523 1082.37 44V24C1082.37 23.4477 1081.92 23 1081.37 23H1061.73C1061.18 23 1060.73 23.4477 1060.73 24V44C1060.73 44.5523 1060.28 45 1059.73 45H1055.55C1055 45 1054.55 44.5523 1054.55 44V17.7143C1054.55 17.162 1055 16.7143 1055.55 16.7143H1065.91C1066.47 16.7143 1066.91 16.2666 1066.91 15.7143V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.04 79.1661L1074.83 78.9292L1074.95 78.6406L1087.95 46.0622C1091.15 38.0432 1087.86 28.775 1080.34 24.5853C1072.81 20.3956 1063.48 22.6367 1058.7 29.7785L1039.3 58.7932L1039.13 59.0501L1038.83 59.0045C1036.54 58.6612 1034.2 59.7667 1033.05 61.9488L1028.7 70.2331C1024.81 77.6141 1027.57 86.8866 1034.86 90.9437L1051.22 100.051C1058.5 104.108 1067.56 101.413 1071.44 94.0323L1075.8 85.748C1076.94 83.5659 1076.57 80.9478 1075.04 79.1661Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.97 77.4107C1031.55 78.2097 1031.51 79.2236 1031.88 80.4257C1032.25 81.6303 1033.01 82.9837 1034.14 84.4015C1036.39 87.2351 1040.02 90.2448 1044.49 92.7356C1048.97 95.2264 1053.4 96.7038 1056.94 97.0938C1058.71 97.2889 1060.23 97.209 1061.41 96.8673C1062.59 96.5262 1063.39 95.9375 1063.81 95.1385C1064.23 94.3394 1064.27 93.3256 1063.9 92.1234C1063.54 90.9188 1062.77 89.5654 1061.64 88.1477C1059.39 85.314 1055.76 82.3043 1051.29 79.8135C1046.82 77.3228 1042.38 75.8453 1038.85 75.4553C1037.08 75.2602 1035.56 75.3401 1034.37 75.6819C1033.2 76.023 1032.39 76.6116 1031.97 77.4107Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.145 2C433.145 1.44772 432.698 1 432.145 1H425.691C425.138 1 424.691 1.44771 424.691 2V15.7143C424.691 16.2666 424.243 16.7143 423.691 16.7143H414.418C413.866 16.7143 413.418 17.162 413.418 17.7143V44C413.418 44.5523 413.866 45 414.418 45H418.054C418.607 45 419.054 44.5523 419.054 44V24C419.054 23.4477 419.502 23 420.054 23H437.782C438.334 23 438.782 23.4477 438.782 24V44C438.782 44.5523 439.229 45 439.782 45H443.418C443.97 45 444.418 44.5523 444.418 44V17.7143C444.418 17.162 443.97 16.7143 443.418 16.7143H434.145C433.593 16.7143 433.145 16.2666 433.145 15.7143V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.281 46.8566L412.281 46.8566L412.28 46.8508C410.154 38.4925 414.415 29.7056 422.127 26.4756C429.839 23.2457 438.544 26.6025 442.288 34.2826L442.294 34.2931L442.299 34.3033L455.258 57.962L455.398 58.2164L455.685 58.2087C457.914 58.1483 460.031 59.5271 460.878 61.8394L464.082 70.595C466.941 78.4056 463.181 87.2608 455.715 90.3876L438.918 97.4226C431.452 100.549 423.071 96.7794 420.212 88.9688L417.007 80.2132C416.161 77.9009 416.84 75.3509 418.514 73.7765L418.739 73.5652L418.667 73.2682L412.281 46.8566Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.82 71.127C460.416 78.2188 455.379 87.1627 446.249 90.9867C437.118 94.8106 427.743 91.9025 425.148 84.8108C422.552 77.7191 427.589 68.7751 436.719 64.9512C445.849 61.1273 455.224 64.0353 457.82 71.127Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.661 2C751.661 1.44772 752.109 1 752.661 1H760.206C760.759 1 761.206 1.44771 761.206 2V15.7143C761.206 16.2666 761.654 16.7143 762.206 16.7143H772.934C773.486 16.7143 773.934 17.162 773.934 17.7143V44C773.934 44.5523 773.486 45 772.934 45H768.57C768.018 45 767.57 44.5523 767.57 44V24C767.57 23.4477 767.122 23 766.57 23H746.297C745.745 23 745.297 23.4477 745.297 24V44C745.297 44.5523 744.85 45 744.297 45H739.934C739.381 45 738.934 44.5523 738.934 44V17.7143C738.934 17.162 739.381 16.7143 739.934 16.7143H750.661C751.213 16.7143 751.661 16.2666 751.661 15.7143V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.969 41.4341L772.969 41.4341L772.969 41.428C772.659 32.7999 765.913 25.6458 757.338 24.8502C748.762 24.0545 741.124 29.8741 739.639 38.3357L739.637 38.3475L739.634 38.3592L733.646 64.8738L733.582 65.1591L733.301 65.2358C731.07 65.8447 729.378 67.7998 729.209 70.2595L728.566 79.5978C727.994 87.918 734.261 95.2874 742.566 96.0579L761.206 97.7874C769.511 98.5578 776.706 92.4375 777.279 84.1174L777.921 74.7791C778.091 72.3194 776.687 70.077 774.568 69.0645L774.29 68.9317L774.275 68.6255L772.969 41.4341Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.912 78.2406C734.393 85.7963 741.951 92.8683 752.1 93.8099C762.248 94.7514 770.678 89.1629 771.198 81.6072C771.718 74.0514 764.159 66.9795 754.011 66.0379C743.862 65.0963 735.432 70.6848 734.912 78.2406Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_5310_24142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.491 769.474L848.168 605.97C848.83 605.736 849.078 604.929 848.661 604.364L455.9 72.5419C455.657 72.212 455.242 72.0552 454.841 72.1412L428.273 77.8344C427.816 77.9324 427.479 78.3221 427.449 78.7886L383.101 768.422C383.053 769.17 383.785 769.723 384.491 769.474Z",
    fill: "url(#paint0_linear_5310_24142)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_5310_24142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.746 761.5H852.318C852.946 761.5 853.432 760.95 853.354 760.327L769.114 81.4158C769.049 80.8927 768.604 80.5 768.077 80.5L736.125 80.5C735.74 80.5 735.386 80.7115 735.205 81.0505L370.826 759.962C370.452 760.657 370.956 761.5 371.746 761.5Z",
    fill: "url(#paint1_linear_5310_24142)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_5310_24142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.845 656.922L1004.82 782.231C1005.44 782.373 1006.05 781.931 1006.1 781.296L1060.94 94.7296C1060.98 94.2916 1060.73 93.8786 1060.33 93.6962L1033.16 81.3002C1032.76 81.1196 1032.3 81.2035 1031.99 81.5107L456.341 655.164C455.758 655.744 456.044 656.739 456.845 656.922Z",
    fill: "url(#paint2_linear_5310_24142)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 400,
    width: 499,
    height: 400,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 651,
    cy: 405.5,
    rx: 250,
    ry: 53.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 970,
    cy: 293.5,
    rx: 130,
    ry: 32.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 660,
    width: 303,
    height: 139,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.5,
    cy: 663.5,
    rx: 151.5,
    ry: 41.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.595 659.541L215.515 646.732L246.592 624.106L247.082 634.805L216.595 659.541Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.883 622.596L247.091 623.068L214.945 646.472L216.139 660.614L208.971 658.017C207.857 657.613 207.048 656.638 206.856 655.468L205.349 646.254C205.144 644.999 205.685 643.738 206.736 643.022L235.872 623.16C236.463 622.757 237.169 622.559 237.883 622.596Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.457 672.853L338.127 665.495L224.584 642.299L220.324 644.679L332.457 672.853Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08 628.894L360.309 637.178L356.199 642.827L239.365 631.248L243.08 628.894Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.131 687.427L378.561 630.337L376.765 648.196C376.712 648.716 376.536 649.216 376.251 649.654L339.954 705.408L339.131 687.427Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.876 628.729L379.025 629.542L339.63 687.404L340.453 705.385L325.719 700.346C324.478 699.922 323.61 698.798 323.514 697.49L322.442 682.934C322.383 682.132 322.621 681.336 323.111 680.698L362.094 630.002C362.754 629.144 363.795 628.667 364.876 628.729Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.742 632.291C351.457 631.818 345.267 631.414 342.439 631.305C341.557 631.271 340.733 631.652 340.147 632.311L306.021 670.701C305.491 671.296 305.758 672.24 306.52 672.47L320.017 676.55C321.301 676.938 322.691 676.503 323.526 675.453L356.448 634.02C356.974 633.359 356.582 632.383 355.742 632.291Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.016 630.698C332.203 630.381 327.608 630.446 325.3 630.513C324.472 630.537 323.692 630.888 323.112 631.48L289.868 665.45C289.3 666.03 289.542 667.006 290.316 667.252L300.317 670.445C301.55 670.838 302.899 670.468 303.759 669.501L336.689 632.443C337.268 631.791 336.885 630.77 336.016 630.698Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.042 629.999C315.166 629.685 310.464 629.738 308.171 629.797C307.389 629.818 306.65 630.133 306.08 630.669L274.257 660.646C273.649 661.219 273.885 662.235 274.683 662.482L283.702 665.27C284.862 665.629 286.124 665.316 286.983 664.458L319.671 631.783C320.308 631.145 319.94 630.071 319.042 629.999Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.666 629.217C298.412 628.921 295.298 628.925 293.55 628.965C292.811 628.982 292.106 629.267 291.549 629.752L261.13 656.265C260.491 656.822 260.703 657.862 261.509 658.125L268.377 660.362C269.509 660.731 270.753 660.455 271.623 659.642L302.268 631.04C302.939 630.413 302.581 629.3 301.666 629.217Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.525 628.341C284.527 628.053 281.96 628.035 280.434 628.064C279.732 628.078 279.06 628.338 278.516 628.782L249.084 652.797C248.41 653.347 248.619 654.426 249.45 654.684L255.725 656.63C256.815 656.968 258.002 656.714 258.858 655.96L288.103 630.19C288.804 629.573 288.454 628.43 287.525 628.341Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.856 627.941C271.021 627.665 268.741 627.638 267.345 627.662C266.679 627.674 266.039 627.911 265.509 628.315L238.019 649.306C237.315 649.844 237.512 650.952 238.358 651.215L243.624 652.847C244.667 653.17 245.802 652.952 246.651 652.265L274.4 629.819C275.143 629.219 274.807 628.033 273.856 627.941Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.228 627.483C258.867 627.224 257.33 627.165 256.264 627.172C255.626 627.176 255.013 627.396 254.496 627.77L228.914 646.256C228.193 646.777 228.365 647.895 229.208 648.176L233.122 649.476C234.15 649.818 235.281 649.629 236.142 648.971L261.746 629.397C262.516 628.808 262.191 627.589 261.228 627.483Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.652 626.952C248.488 626.702 247.183 626.634 246.234 626.633C245.593 626.632 244.975 626.857 244.457 627.235L221.293 644.102C220.575 644.624 220.748 645.739 221.59 646.019L224.564 647.009C225.581 647.348 226.699 647.167 227.557 646.525L251.161 628.88C251.942 628.296 251.621 627.064 250.652 626.952Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.856,
    cy: 637.797,
    rx: 3.75195,
    ry: 2.5013,
    transform: "rotate(3.94562 343.856 637.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.397,
    cy: 636.088,
    rx: 3.39014,
    ry: 2.26009,
    transform: "rotate(3.94562 326.397 636.088)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.506,
    cy: 635.033,
    rx: 3.5548,
    ry: 2.36986,
    transform: "rotate(3.94562 308.506 635.033)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.811,
    cy: 633.314,
    rx: 2.99426,
    ry: 1.99618,
    transform: "rotate(3.94562 292.811 633.314)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.536,
    cy: 632.75,
    rx: 2.77495,
    ry: 1.84997,
    transform: "rotate(3.94562 279.536 632.75)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.659,
    cy: 631.516,
    rx: 2.29918,
    ry: 1.53278,
    transform: "rotate(3.94562 266.659 631.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.682,
    cy: 630.362,
    rx: 2.10353,
    ry: 1.40236,
    transform: "rotate(3.94562 254.682 630.362)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.645,
    cy: 629.775,
    rx: 2.10353,
    ry: 1.40236,
    transform: "rotate(3.94562 245.645 629.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.12,
    cy: 666.65,
    rx: 3.70297,
    ry: 2.46865,
    transform: "rotate(3.94562 320.12 666.65)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.198,
    cy: 661.938,
    rx: 3.52012,
    ry: 2.34674,
    transform: "rotate(3.94562 302.198 661.938)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.268,
    cy: 657.932,
    rx: 3.31302,
    ry: 2.20868,
    transform: "rotate(3.94562 285.268 657.932)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.75,
    cy: 654.39,
    rx: 2.99426,
    ry: 1.99618,
    transform: "rotate(3.94562 269.75 654.39)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.338,
    cy: 650.784,
    rx: 2.77495,
    ry: 1.84997,
    transform: "rotate(3.94562 257.338 650.784)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.778,
    cy: 648.05,
    rx: 2.38131,
    ry: 1.58754,
    transform: "rotate(3.94562 244.778 648.05)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.262,
    cy: 645.797,
    rx: 2.26013,
    ry: 1.50675,
    transform: "rotate(3.94562 234.262 645.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.924,
    cy: 643.551,
    rx: 1.96598,
    ry: 1.31065,
    transform: "rotate(3.94562 225.924 643.551)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.647,
    y: 253.73,
    width: 8.82457,
    height: 44.1229,
    rx: 4.41229,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.823,
    y: 253.73,
    width: 8.82457,
    height: 44.1229,
    rx: 4.41229,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731.157,
    y: 342.852,
    width: 8.82457,
    height: 46.9581,
    rx: 4.41229,
    transform: "rotate(-25.2281 731.157 342.852)",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.60612,
    y: -0.187074,
    width: 9.15351,
    height: 59.0895,
    rx: 4.57675,
    transform: "matrix(-0.806727 -0.590925 -0.649317 0.760518 577.95 340.937)",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.10992,
    height: 55.4709,
    rx: 3.55496,
    transform: "matrix(-0.969331 0.245758 0.283397 0.959003 570.848 340.873)",
    fill: "#5CBCD1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.503,
    y: 255.936,
    width: 8.82457,
    height: 44.1229,
    rx: 4.41229,
    transform: "rotate(90 671.503 255.936)",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.739 222.374C704.723 222.333 704.707 222.291 704.689 222.25C704.672 222.209 704.653 222.168 704.635 222.128L704.326 221.4L704.228 221.442C701.071 217.15 688.911 217.893 676.034 223.353C663.156 228.813 654.168 237.036 655.058 242.289L654.955 242.332L670.277 278.472L719.648 257.539L704.739 222.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.318 257.807C718.418 258.044 718.416 258.675 717.487 259.894C716.618 261.036 715.156 262.392 713.162 263.871C709.188 266.818 703.303 270.105 696.452 273.01C689.601 275.915 683.146 277.859 678.265 278.666C675.815 279.071 673.824 279.18 672.4 279.011C670.878 278.83 670.423 278.393 670.322 278.156C670.222 277.919 670.224 277.288 671.153 276.069C672.021 274.928 673.484 273.572 675.478 272.093C679.452 269.146 685.337 265.858 692.188 262.953C699.039 260.048 705.494 258.105 710.375 257.297C712.824 256.892 714.816 256.784 716.24 256.953C717.762 257.133 718.217 257.57 718.318 257.807Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.821 247.184C638.84 247.131 638.858 247.077 638.875 247.022C638.891 246.968 638.907 246.913 638.921 246.859L639.146 246.132L639.044 246.1C639.398 240.75 629.561 233.434 616.112 229.28C602.663 225.127 590.413 225.622 587.689 230.24L587.58 230.207L575.923 267.952L627.489 283.877L638.821 247.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.056 283.659C626.968 283.945 626.527 284.444 625.027 284.796C623.613 285.128 621.604 285.239 619.107 285.097C614.13 284.815 607.466 283.545 600.311 281.336C593.157 279.126 586.937 276.417 582.668 273.844C580.526 272.553 578.929 271.328 577.949 270.257C576.908 269.12 576.826 268.46 576.914 268.173C577.003 267.887 577.443 267.388 578.943 267.036C580.357 266.704 582.366 266.593 584.863 266.735C589.84 267.017 596.504 268.287 603.659 270.496C610.813 272.706 617.033 275.415 621.302 277.988C623.445 279.279 625.041 280.504 626.022 281.575C627.062 282.712 627.145 283.372 627.056 283.659Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 747.658,
    cy: 190.676,
    rx: 33.4019,
    ry: 12.3296,
    transform: "rotate(-13.286 747.658 190.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.674,
    cy: 211.647,
    rx: 33.4019,
    ry: 12.3296,
    transform: "rotate(7.1294 561.674 211.647)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.368,
    y: 214.247,
    width: 8.06372,
    height: 137.767,
    rx: 4.03186,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.961,
    y: 284.849,
    width: 70.5966,
    height: 20.0049,
    transform: "rotate(8.1341 535.961 284.849)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.865 294.25C603.304 294.425 603.669 294.587 603.965 294.735C603.64 294.794 603.244 294.847 602.773 294.891C601.018 295.057 598.462 295.076 595.272 294.946C588.904 294.687 580.15 293.84 570.526 292.464C560.901 291.089 552.261 289.449 546.075 287.914C542.976 287.145 540.528 286.411 538.889 285.76C538.45 285.586 538.085 285.424 537.79 285.276C538.114 285.217 538.51 285.164 538.981 285.12C540.736 284.954 543.292 284.935 546.482 285.065C552.85 285.324 561.604 286.171 571.229 287.546C580.853 288.922 589.493 290.562 595.679 292.097C598.778 292.866 601.226 293.6 602.865 294.25Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.107,
    cy: 309.386,
    rx: 35.2983,
    ry: 7.7215,
    transform: "rotate(8.1341 568.107 309.386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.305,
    y: 187.546,
    width: 8.82457,
    height: 103.689,
    rx: 4.41229,
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.156,
    y: 284.839,
    width: 70.5966,
    height: 54.0259,
    transform: "rotate(-0.0396141 699.156 284.839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.74 284.557C767.062 284.628 767.348 284.699 767.598 284.768C767.348 284.837 767.062 284.908 766.741 284.979C765.022 285.362 762.49 285.715 759.312 286.015C752.969 286.614 744.181 286.99 734.456 286.997C724.732 287.003 715.943 286.64 709.599 286.049C706.421 285.754 703.889 285.404 702.169 285.024C701.848 284.953 701.562 284.882 701.312 284.813C701.562 284.744 701.847 284.673 702.169 284.602C703.888 284.219 706.419 283.866 709.597 283.566C715.941 282.967 724.729 282.591 734.453 282.584C744.178 282.578 752.966 282.941 759.311 283.532C762.489 283.827 765.021 284.177 766.74 284.557Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.495,
    cy: 339.944,
    rx: 35.2983,
    ry: 7.7215,
    transform: "rotate(-0.0396141 734.495 339.944)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.563 306.261C593.668 292.522 611.442 284.804 629.975 284.804V358.064L629.975 431.324C611.442 431.324 593.668 423.606 580.563 409.867C567.458 396.128 560.096 377.494 560.096 358.064C560.096 338.634 567.458 320 580.563 306.261ZM663.787 284.804H629.975V431.324H663.787V284.804Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.458 358.064C731.458 397.406 701.063 429.118 663.785 429.118C626.508 429.118 596.112 397.406 596.112 358.064C596.112 318.723 626.508 287.01 663.785 287.01C701.063 287.01 731.458 318.723 731.458 358.064Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 4.41229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 759,
    width: 234,
    height: 41,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 542,
    cy: 763,
    rx: 117,
    ry: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.5,
    cy: 761.627,
    rx: 38.5,
    ry: 11,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.585 752.105C533.02 751.327 532.098 750.889 531.139 750.957C525.97 751.328 521.12 752.001 516.9 752.936C512.264 753.964 508.512 755.281 505.929 756.786C503.347 758.291 502.003 759.946 502 761.622C501.997 763.299 503.336 764.953 505.913 766.459C508.491 767.965 512.239 769.283 516.872 770.312C521.505 771.341 526.899 772.054 532.643 772.396C538.388 772.738 544.33 772.7 550.015 772.286C551.166 772.202 552.3 772.103 553.414 771.99C556.932 771.632 557.229 767.245 553.877 766.119C553.246 765.907 552.569 765.882 551.918 766.021C549.921 766.444 547.651 766.753 545.234 766.93C542.405 767.136 539.449 767.154 536.592 766.984C533.734 766.814 531.05 766.459 528.746 765.948C526.441 765.436 524.577 764.78 523.294 764.031C522.012 763.282 521.346 762.459 521.348 761.625C521.349 760.791 522.017 759.968 523.302 759.219C524.587 758.47 526.454 757.815 528.76 757.304C529.621 757.113 530.536 756.944 531.492 756.798C533.693 756.463 534.893 753.906 533.585 752.105Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-1_5310_24142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548 748.627C548 746.97 543.971 745.627 539 745.627C534.029 745.627 530 746.97 530 748.627V753.627C530 755.836 534.029 757.627 539 757.627C543.971 757.627 548 755.836 548 753.627V748.627Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548 748.627C548 746.97 543.971 745.627 539 745.627C534.029 745.627 530 746.97 530 748.627V753.627C530 755.836 534.029 757.627 539 757.627C543.971 757.627 548 755.836 548 753.627V748.627Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 746.627C541.408 746.627 543.546 746.954 545.048 747.455C545.804 747.707 546.344 747.985 546.674 748.245C546.836 748.373 546.922 748.477 546.965 748.546C546.985 748.579 546.994 748.601 546.997 748.612C547 748.622 547 748.626 547 748.627H549C549 747.775 548.481 747.123 547.912 746.674C547.331 746.216 546.553 745.848 545.68 745.557C543.925 744.972 541.563 744.627 539 744.627V746.627ZM531 748.627C531 748.626 531 748.622 531.003 748.612C531.006 748.601 531.015 748.579 531.035 748.546C531.078 748.477 531.164 748.373 531.326 748.245C531.656 747.985 532.196 747.707 532.952 747.455C534.454 746.954 536.592 746.627 539 746.627V744.627C536.437 744.627 534.075 744.972 532.32 745.557C531.447 745.848 530.669 746.216 530.088 746.674C529.519 747.123 529 747.775 529 748.627H531ZM529 748.627V753.627H531V748.627H529ZM529 753.627C529 754.505 529.404 755.266 529.983 755.874C530.556 756.476 531.339 756.974 532.23 757.369C534.014 758.162 536.408 758.627 539 758.627V756.627C536.621 756.627 534.516 756.197 533.042 755.542C532.304 755.214 531.769 754.849 531.432 754.495C531.099 754.146 531 753.854 531 753.627H529ZM539 758.627C541.592 758.627 543.986 758.162 545.77 757.369C546.661 756.974 547.444 756.476 548.017 755.874C548.596 755.266 549 754.505 549 753.627H547C547 753.854 546.901 754.146 546.568 754.495C546.231 754.849 545.696 755.214 544.958 755.542C543.484 756.197 541.379 756.627 539 756.627V758.627ZM549 753.627V748.627H547V753.627H549Z",
    fill: "white",
    mask: "url(#path-80-inside-1_5310_24142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.5,
    y: 566.5,
    width: 6,
    height: 183,
    rx: 3,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.14,
    cy: 547.656,
    rx: 21.5,
    ry: 20.2127,
    transform: "rotate(-21.365 566.14 547.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-84-inside-2_5310_24142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.238 538.627C556.073 539.531 563 548.144 563 558.635C563 561.868 562.343 564.922 561.174 567.627C554.411 566.884 548.502 562.375 546.093 555.225C544.243 549.735 544.819 543.763 547.238 538.627Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.238 538.627C556.073 539.531 563 548.144 563 558.635C563 561.868 562.343 564.922 561.174 567.627C554.411 566.884 548.502 562.375 546.093 555.225C544.243 549.735 544.819 543.763 547.238 538.627Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.238 538.627L547.34 537.632L546.636 537.56L546.334 538.201L547.238 538.627ZM561.174 567.627L561.065 568.621L561.799 568.702L562.092 568.024L561.174 567.627ZM546.093 555.225L545.145 555.544H545.145L546.093 555.225ZM547.137 539.622C555.35 540.463 562 548.538 562 558.635H564C564 547.75 556.795 538.6 547.34 537.632L547.137 539.622ZM562 558.635C562 561.732 561.37 564.651 560.256 567.23L562.092 568.024C563.315 565.192 564 562.003 564 558.635H562ZM561.283 566.633C554.908 565.933 549.326 561.688 547.04 554.906L545.145 555.544C547.678 563.063 553.914 567.836 561.065 568.621L561.283 566.633ZM547.04 554.906C545.281 549.685 545.822 543.98 548.143 539.053L546.334 538.201C543.816 543.546 543.204 549.785 545.145 555.544L547.04 554.906Z",
    fill: "white",
    mask: "url(#path-84-inside-2_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 563.627C559.9 553.227 551.5 544.127 546 544.127L505.5 567.127L511.5 578.627L551.5 563.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 563.627C556.5 557.127 555 553.627 554.5 551.627L509.5 574.627L511.5 578.627L551.5 563.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.072,
    cy: 572.592,
    rx: 5,
    ry: 6.58812,
    transform: "rotate(-21.5778 509.072 572.592)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.546 560.915L544.979 555.641C546.477 555.005 548.316 555.19 548.729 556.764C549.704 560.486 547.895 567.277 545.744 569.284C543.037 571.811 536.538 574.338 532.206 575.349C530.723 575.695 529.122 575.683 527.647 575.504C526.156 575.322 526.102 573.178 527.332 572.316C528.533 571.476 529.109 568.324 529.351 565.514C529.522 563.514 530.698 561.699 532.546 560.915Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.552 681.376L207.7 676.205C206.743 676.14 206 675.344 206 674.385C206 673.337 206.881 672.504 207.928 672.564L283.833 676.877C285.026 676.944 285.959 677.932 285.959 679.127C285.959 680.433 284.854 681.465 283.552 681.376Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.756 681.458L206.637 676.132C206.279 676.108 206 675.81 206 675.45C206 675.057 206.33 674.745 206.723 674.767L284.896 679.209C285.493 679.242 285.959 679.736 285.959 680.334C285.959 680.987 285.407 681.503 284.756 681.458Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.776,
    cy: 679.723,
    r: 7.72335,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.95 676.921C281.324 676.62 280.561 676.882 280.365 677.549C279.973 678.887 279.947 680.314 280.304 681.677C280.767 683.449 281.845 684.999 283.346 686.05C284.846 687.1 286.671 687.584 288.494 687.413C289.898 687.282 291.23 686.771 292.353 685.945C292.913 685.533 292.898 684.726 292.401 684.241C291.904 683.755 291.112 683.781 290.522 684.147C289.842 684.569 289.068 684.832 288.26 684.907C287.031 685.022 285.801 684.696 284.789 683.988C283.778 683.28 283.051 682.235 282.739 681.041C282.533 680.255 282.516 679.439 282.68 678.655C282.823 677.975 282.576 677.222 281.95 676.921Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 719,
    width: 402,
    height: 81,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 901,
    cy: 715.5,
    rx: 201,
    ry: 60.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.8 161.141L1100.43 163.363L1099.11 167.377L1092.5 166.075L1093.8 161.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025.25,
    y: 178.701,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1025.25 178.701)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.3,
    y: 191.382,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1016.3 191.382)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.52,
    y: 205.84,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1008.52 205.84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 999.762,
    y: 220.639,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 999.762 220.639)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.65,
    y: 234.939,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 991.65 234.939)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.38,
    y: 173.348,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1023.38 173.348)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.43,
    y: 186.029,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1014.43 186.029)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.65,
    y: 200.487,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1006.65 200.487)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997.891,
    y: 215.285,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 997.891 215.285)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 989.781,
    y: 229.585,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 989.781 229.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.24 161.4C1060.62 158.975 1078.92 164.051 1088.41 166.47L1090.79 161.545C1084.07 159.385 1067.94 153.964 1057.79 151.5C1047.95 149.109 1042.43 154.545 1040.36 158.27L985.678 250.675C983.432 255.191 977.27 263.577 970.581 260.999C963.892 258.42 966.095 250.539 967.842 246.12C972.746 233.714 983.389 202.221 981.774 194.158C980.159 186.094 980.816 186.074 981.64 184.785C985.954 180.876 983.01 179.847 980.999 179.822C962.677 183.126 924.623 190.228 918.978 192.2C913.332 194.172 915.2 195.977 916.84 196.632C930.257 200.028 928.91 210.346 926.559 215.08C908.013 280.803 923.4 290.855 942.901 297.832C957.659 303.112 977.135 291.882 985.903 277.899C994.67 263.916 1045.93 171.478 1045.93 171.478C1049.51 165.313 1052.64 162.573 1055.24 161.4Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.17 159.716C1057.17 157.464 1063.36 158.801 1071.82 160.941C1072.8 161.189 1073.74 160.414 1073.68 159.405C1073.65 158.864 1073.32 158.382 1072.83 158.149C1067.89 155.789 1064.42 154.451 1056.36 153.64C1046.28 152.625 1043.76 158.423 1041.69 162.148L987.98 254.214C981.118 264.664 975.937 275.999 965.102 267.664C958.756 262.782 958.194 254.417 961.217 246.77C966.122 234.363 972.13 217.431 974.04 208.436C975.462 201.736 975.289 194.403 975.668 191.396C975.776 190.542 976.321 189.867 976.914 189.243C979.396 186.636 978.275 185.74 976.765 185.5C976.154 185.403 975.534 185.481 974.924 185.59C956.769 188.829 934.71 191.731 929.158 193.67C923.512 195.641 925.38 197.446 927.02 198.102C940.437 201.498 934.818 215.218 932.467 219.953C909.803 277.012 940.319 289.68 944.979 291.347C958.785 296.286 971.724 289.677 981.847 275.74C991.648 262.247 1040.24 176.414 1043.32 170.968C1043.43 170.785 1043.52 170.602 1043.61 170.413C1046.06 165.434 1049.62 160.867 1052.17 159.716Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.77,
    y: 155.743,
    width: 5.83235,
    height: 15.3099,
    rx: 2.91617,
    transform: "rotate(25.7481 1091.77 155.743)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.79,
    y: 157.373,
    width: 3.28069,
    height: 9.11304,
    rx: 1.64035,
    transform: "rotate(25.7481 1091.79 157.373)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.054 231.847C936.936 225.873 938.364 219.39 938.999 214.114C939.597 209.133 944.937 203.588 947.07 208.13C948.445 211.059 948.061 216.688 943.119 227.316C932.284 250.622 932.895 264.879 934.703 271.619C936.511 278.359 948.798 293.998 936.144 281.217C923.489 268.437 927.878 244.652 934.054 231.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.28 164.409C1045.72 161.939 1047.24 160.3 1048.67 159.24C1051.53 157.112 1054.24 154.891 1050.8 155.815C1048.88 156.328 1046.69 157.419 1045.27 159.015C1041.74 162.978 1039.59 172.464 1044.28 164.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.065 286.867C956.239 288.051 952.689 287.937 949.377 288.019C946.121 288.098 950.969 291.474 955.363 291.092C959.756 290.71 962.783 285.309 959.065 286.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100.5,
    y: 616.01,
    width: 98.908,
    height: 183.49,
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.63 615.01L1123.03 600.5H1199.41V615.01H1101.63Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.88 615.51H1109.45V789.009H1191.05V615.51H1195.63V793.72H1191.05L1109.45 793.72L1104.88 793.72V615.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.55,
    cy: 672.653,
    rx: 25.9923,
    ry: 26.1224,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.17 672.653C1170.17 684.101 1160.93 693.377 1149.55 693.377C1138.16 693.377 1128.93 684.101 1128.93 672.653C1128.93 661.205 1138.16 651.928 1149.55 651.928C1160.93 651.928 1170.17 661.205 1170.17 672.653Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.14,
    cy: 673.061,
    rx: 7.71647,
    ry: 7.7551,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.6 666.686C1153.71 667.278 1154.65 668.149 1155.33 669.215C1156 670.281 1156.39 671.504 1156.45 672.766C1156.52 674.027 1156.25 675.284 1155.69 676.413C1155.13 677.542 1154.28 678.504 1153.23 679.206C1152.19 679.908 1150.98 680.325 1149.73 680.418C1148.47 680.51 1147.22 680.274 1146.08 679.732C1144.95 679.191 1143.97 678.363 1143.25 677.328C1142.53 676.294 1142.08 675.09 1141.97 673.832L1142.81 673.862C1147.34 674.02 1151.38 671.058 1152.6 666.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.55,
    cy: 742.041,
    rx: 32.4904,
    ry: 32.6531,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.45 742.041C1175.45 756.42 1163.85 768.071 1149.55 768.071C1135.25 768.071 1123.65 756.42 1123.65 742.041C1123.65 727.662 1135.25 716.01 1149.55 716.01C1163.85 716.01 1175.45 727.662 1175.45 742.041Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.04,
    cy: 742.551,
    rx: 9.64559,
    ry: 9.69388,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.41 734.479C1154.81 735.227 1155.99 736.327 1156.85 737.672C1157.7 739.017 1158.19 740.561 1158.27 742.154C1158.35 743.746 1158.02 745.333 1157.3 746.758C1156.59 748.183 1155.52 749.397 1154.21 750.284C1152.89 751.17 1151.36 751.697 1149.78 751.813C1148.2 751.93 1146.61 751.632 1145.18 750.948C1143.74 750.265 1142.51 749.219 1141.6 747.914C1140.69 746.608 1140.13 745.087 1139.98 743.5L1142.96 743.604C1147.55 743.765 1151.65 740.759 1152.89 736.323L1153.41 734.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.49,
    cy: 777.143,
    rx: 6.49808,
    ry: 6.53061,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.49,
    cy: 777.143,
    rx: 4.87356,
    ry: 4.89796,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1128.43,
    y: 622.857,
    width: 42.2375,
    height: 15.5102,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.17 664.56L1123 674.5L1124.06 682.497L1109 672L1111.04 680.877L1083.68 663.806L1104.55 673.467L1103.17 664.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.82 765.239L1119.21 757.396L1122.5 762.5L1104.32 765.239L1115.81 769.549L1078.32 781.239L1103.32 769.549L1092.82 765.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 99,
    height: 182.567,
    transform: "matrix(-1 0 0 1 99 616.433)",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3633 615.933L76.9465 601.5H0.5V615.933H98.3633Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1211 616.433H90.5409V789.064H8.86403V616.433H4.28387V793.751L8.86403 793.751H90.5434L95.1211 793.751V616.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0163,
    cy: 25.9918,
    rx: 26.0163,
    ry: 25.9918,
    transform: "matrix(-1 0 0 1 76.4238 647.298)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7724 673.29C29.7724 684.677 39.012 693.908 50.4106 693.908C61.8092 693.908 71.0488 684.677 71.0488 673.29C71.0488 661.903 61.8092 652.671 50.4106 652.671C39.012 652.671 29.7724 661.903 29.7724 673.29Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.72358,
    cy: 7.71633,
    rx: 7.72358,
    ry: 7.71633,
    transform: "matrix(-1 0 0 1 58.5371 665.98)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3525 667.352C46.2412 667.941 45.3019 668.809 44.6264 669.869C43.9509 670.929 43.5623 672.147 43.4986 673.402C43.4349 674.657 43.6982 675.908 44.2629 677.031C44.8275 678.154 45.6742 679.112 46.7201 679.81C47.766 680.509 48.9754 680.924 50.2302 681.016C51.4849 681.108 52.742 680.873 53.8786 680.334C55.0153 679.795 55.9925 678.971 56.715 677.942C57.4374 676.913 57.8803 675.714 58.0003 674.463L57.1347 674.493C52.6177 674.65 48.5773 671.701 47.3525 667.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5203,
    cy: 32.4898,
    rx: 32.5203,
    ry: 32.4898,
    transform: "matrix(-1 0 0 1 82.9277 709.841)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4826 742.331C24.4826 756.633 36.0882 768.229 50.4054 768.229C64.7226 768.229 76.3281 756.633 76.3281 742.331C76.3281 728.028 64.7226 716.433 50.4054 716.433C36.0882 716.433 24.4826 728.028 24.4826 742.331Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.65447,
    cy: 9.64541,
    rx: 9.65447,
    ry: 9.64541,
    transform: "matrix(-1 0 0 1 60.5703 733.192)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5426 734.807C45.1398 735.551 43.9541 736.645 43.1015 737.984C42.2488 739.322 41.7582 740.859 41.6778 742.443C41.5974 744.028 41.9298 745.606 42.6425 747.024C43.3553 748.442 44.4241 749.651 45.7444 750.533C47.0646 751.414 48.5913 751.939 50.1751 752.055C51.759 752.17 53.3458 751.874 54.7806 751.194C56.2154 750.514 57.4491 749.473 58.361 748.174C59.2729 746.875 59.832 745.362 59.9835 743.783L57.0286 743.886C52.4198 744.046 48.2972 741.037 47.0476 736.6L46.5426 734.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.50407,
    cy: 6.49796,
    rx: 6.50407,
    ry: 6.49796,
    transform: "matrix(-1 0 0 1 86.9941 770.759)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.87805,
    cy: 4.87347,
    rx: 4.87805,
    ry: 4.87347,
    transform: "matrix(-1 0 0 1 85.3691 772.384)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.2764,
    height: 15.4327,
    rx: 5,
    transform: "matrix(-1 0 0 1 71.543 623.743)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49 653.56L78.1169 663.5L77.0771 671.497L91.7912 661L89.7981 669.877L116.522 652.806L96.1348 662.467L97.49 653.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.592 754.239L81.8191 746.396L78.6051 751.5L96.3599 754.239L85.1389 758.549L121.755 770.239L97.3367 758.549L107.592 754.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7101,
    cy: 562.258,
    rx: 41.2762,
    ry: 42.6505,
    transform: "rotate(33.9574 61.7101 562.258)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1288 528.822C81.482 527.589 81.5887 526.297 81.4429 525.022C81.297 523.748 80.9015 522.514 80.2789 521.392C79.6563 520.27 78.8187 519.281 77.8141 518.483C76.8095 517.684 75.6574 517.092 74.4237 516.738C73.19 516.385 71.8989 516.279 70.6239 516.424C69.349 516.57 68.1152 516.966 66.9932 517.588C65.8711 518.211 64.8826 519.048 64.0842 520.053C63.2858 521.058 62.6931 522.21 62.3399 523.444L71.7344 526.133L81.1288 528.822Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1191 524.202C55.5098 523.072 54.684 522.074 53.6889 521.264C52.6937 520.453 51.5487 519.847 50.3193 519.48C49.0899 519.112 47.8 518.99 46.5235 519.121C45.2469 519.251 44.0086 519.632 42.8792 520.242C41.7499 520.851 40.7516 521.677 39.9414 522.672C39.1312 523.667 38.5249 524.812 38.1572 526.041C37.7895 527.271 37.6675 528.561 37.7983 529.837C37.929 531.114 38.3099 532.352 38.9193 533.482L47.5192 528.842L56.1191 524.202Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.98 535.836C36.9647 535.051 35.8047 534.474 34.5664 534.137C33.328 533.801 32.0355 533.712 30.7627 533.875C29.4898 534.038 28.2616 534.45 27.148 535.088C26.0344 535.725 25.0574 536.576 24.2726 537.591C23.4879 538.607 22.9108 539.767 22.5743 541.005C22.2379 542.243 22.1486 543.536 22.3117 544.809C22.4747 546.082 22.8869 547.31 23.5246 548.424C24.1624 549.537 25.0132 550.514 26.0285 551.299L32.0043 543.567L37.98 535.836Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6441 527.605C78.7444 527.889 79.8896 527.223 79.937 526.087C79.9616 525.496 79.9325 524.901 79.8492 524.312C79.6695 523.041 79.2414 521.819 78.5891 520.713C77.9369 519.608 77.0734 518.642 76.0479 517.871C75.0224 517.1 73.855 516.538 72.6123 516.217C71.3697 515.897 70.0761 515.825 68.8055 516.005C67.5349 516.184 66.3121 516.612 65.207 517.265C64.1018 517.917 63.136 518.78 62.3646 519.806C62.0602 520.211 61.7551 520.507 61.4775 520.793C60.7282 521.566 61.2857 522.669 62.3056 523.014L70.1736 525.68L77.6441 527.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6892 522.738C55.186 523.291 55.0102 524.212 54.2324 524.659L47.5589 528.492L40.0842 532.074C39.7126 532.252 39.3281 532.251 39.0613 532.138C38.8174 532.034 38.6571 531.837 38.6558 531.512C38.6556 531.458 38.6557 531.401 38.6557 531.343C38.6561 530.995 38.6566 530.588 38.5966 530.124C38.4404 528.917 38.5235 527.69 38.8413 526.515C39.159 525.339 39.7052 524.238 40.4486 523.274C41.1919 522.309 42.118 521.501 43.1738 520.895C44.2296 520.288 45.3946 519.896 46.6021 519.739C47.8096 519.583 49.0361 519.666 50.2115 519.984C51.3869 520.302 52.4882 520.848 53.4525 521.591C53.8998 521.936 54.3135 522.32 54.6892 522.738Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.442 534.168C37.1205 534.472 37.3335 535.384 36.804 536.108L32.2612 542.32L26.8845 548.629C26.6172 548.942 26.2655 549.098 25.9755 549.102C25.7106 549.106 25.4839 548.991 25.3511 548.695C25.3287 548.645 25.3059 548.594 25.2824 548.541C25.1415 548.223 24.9766 547.85 24.7334 547.451C24.1004 546.411 23.6785 545.256 23.4918 544.053C23.305 542.85 23.3571 541.621 23.645 540.438C23.9328 539.255 24.4509 538.14 25.1697 537.158C25.8884 536.175 26.7936 535.343 27.8338 534.71C28.8739 534.077 30.0285 533.655 31.2317 533.468C32.4349 533.282 33.6631 533.334 34.8461 533.622C35.3949 533.755 35.9289 533.938 36.442 534.168Z",
    fill: "white",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7495 586.611C26.9676 587.628 26.3938 588.79 26.0609 590.029C25.728 591.269 25.6424 592.561 25.8091 593.834C25.9757 595.106 26.3914 596.333 27.0323 597.445C27.6732 598.557 28.5268 599.531 29.5443 600.313C30.5619 601.095 31.7235 601.669 32.9628 602.002C34.2021 602.335 35.4949 602.42 36.7673 602.254C38.0396 602.087 39.2667 601.671 40.3785 601.03C41.4902 600.389 42.4649 599.536 43.2467 598.518L35.4981 592.564L27.7495 586.611Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4435 584.545L44.2874 598.886C44.5837 599.124 44.5452 599.586 44.2137 599.772C44.0224 599.879 43.785 599.859 43.6143 599.722L25.7999 585.344C25.5928 585.177 25.5479 584.879 25.6966 584.659C25.8644 584.409 26.2093 584.357 26.4435 584.545Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-155-inside-3_5310_24142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0175 586.306C27.1165 585.614 25.8018 585.778 25.3131 586.804C25.0583 587.338 24.852 587.897 24.6976 588.471C24.3647 589.711 24.2791 591.003 24.4458 592.276C24.6124 593.548 25.0281 594.775 25.669 595.887C26.3099 596.999 27.1635 597.973 28.1811 598.755C29.1986 599.537 30.3602 600.111 31.5995 600.444C32.8388 600.777 34.1316 600.862 35.404 600.696C36.6764 600.529 37.9035 600.113 39.0152 599.472C39.5309 599.175 40.017 598.832 40.4682 598.448C41.3334 597.712 41.1531 596.399 40.2521 595.707L34.1348 591.007L28.0175 586.306Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0175 586.306C27.1165 585.614 25.8018 585.778 25.3131 586.804C25.0583 587.338 24.852 587.897 24.6976 588.471C24.3647 589.711 24.2791 591.003 24.4458 592.276C24.6124 593.548 25.0281 594.775 25.669 595.887C26.3099 596.999 27.1635 597.973 28.1811 598.755C29.1986 599.537 30.3602 600.111 31.5995 600.444C32.8388 600.777 34.1316 600.862 35.404 600.696C36.6764 600.529 37.9035 600.113 39.0152 599.472C39.5309 599.175 40.017 598.832 40.4682 598.448C41.3334 597.712 41.1531 596.399 40.2521 595.707L34.1348 591.007L28.0175 586.306Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    mask: "url(#path-155-inside-3_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5186 559.275C21.2652 559.55 20.0782 560.069 19.0255 560.803C17.9728 561.537 17.0749 562.471 16.3832 563.552C15.6914 564.633 15.2193 565.839 14.9938 567.103C14.7684 568.366 14.7939 569.661 15.069 570.915C15.3442 572.168 15.8635 573.355 16.5973 574.408C17.3311 575.46 18.2651 576.358 19.346 577.05C20.4268 577.742 21.6333 578.214 22.8966 578.439C24.1599 578.665 25.4552 578.639 26.7086 578.364L24.6136 568.82L22.5186 559.275Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-157-inside-4_5310_24142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9072 557.308C20.6538 557.583 19.4669 558.103 18.4142 558.836C17.3615 559.57 16.4636 560.504 15.7718 561.585C15.0801 562.666 14.608 563.872 14.3825 565.136C14.157 566.399 14.1826 567.694 14.4577 568.948C14.7328 570.201 15.2521 571.388 15.986 572.441C16.7198 573.494 17.6538 574.391 18.7347 575.083C19.8155 575.775 21.022 576.247 22.2853 576.472C23.5486 576.698 24.8439 576.672 26.0973 576.397L24.0023 566.853L21.9072 557.308Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9072 557.308C20.6538 557.583 19.4669 558.103 18.4142 558.836C17.3615 559.57 16.4636 560.504 15.7718 561.585C15.0801 562.666 14.608 563.872 14.3825 565.136C14.157 566.399 14.1826 567.694 14.4577 568.948C14.7328 570.201 15.2521 571.388 15.986 572.441C16.7198 573.494 17.6538 574.391 18.7347 575.083C19.8155 575.775 21.022 576.247 22.2853 576.472C23.5486 576.698 24.8439 576.672 26.0973 576.397L24.0023 566.853L21.9072 557.308Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    mask: "url(#path-157-inside-4_5310_24142)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.8673,
    cy: 560.456,
    rx: 37.2438,
    ry: 41.9301,
    transform: "rotate(33.9574 57.8673 560.456)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8885,
    cy: 559.727,
    rx: 35.3766,
    ry: 40.6301,
    transform: "rotate(33.9574 56.8885 559.727)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0874 522.257C66.263 521.541 66.9532 521.072 67.6777 521.205C74.2554 522.409 80.1573 525.576 84.7151 530.363C89.5669 535.46 92.6777 542.164 93.6542 549.628C94.6306 557.092 93.4289 564.981 90.2009 572.296C86.973 579.612 81.8637 586.027 75.5194 590.729C69.175 595.43 61.8804 598.208 54.5581 598.711C47.2357 599.214 40.2145 597.42 34.3823 593.554C28.55 589.689 24.1687 583.926 21.7924 576.996C19.5348 570.411 19.1832 563.052 20.7663 555.765C20.9084 555.111 21.5365 554.688 22.1988 554.783C22.9609 554.891 23.4609 555.634 23.3039 556.387C21.918 563.038 22.2676 569.74 24.3274 575.748C26.5321 582.179 30.597 587.525 36.0079 591.111C41.4189 594.697 47.933 596.362 54.7264 595.896C61.5199 595.429 68.2875 592.852 74.1736 588.489C80.0597 584.127 84.7999 578.176 87.7947 571.389C90.7895 564.601 91.9045 557.282 90.9985 550.357C90.0926 543.432 87.2065 537.213 82.7052 532.484C78.5628 528.133 73.2237 525.225 67.2708 524.058C66.439 523.895 65.8853 523.08 66.0874 522.257Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.231 552.074C102.407 551.561 103.471 550.822 104.361 549.898C105.252 548.974 105.952 547.883 106.421 546.689C106.89 545.494 107.119 544.219 107.095 542.936C107.072 541.653 106.795 540.387 106.283 539.211C105.77 538.035 105.03 536.971 104.106 536.08C103.182 535.19 102.092 534.49 100.897 534.021C99.7029 533.552 98.4278 533.323 97.1447 533.347C95.8617 533.37 94.5959 533.646 93.4196 534.159L97.3252 543.117L101.231 552.074Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4929 578.528C97.745 578.809 99.0401 578.841 100.304 578.621C101.569 578.402 102.778 577.935 103.862 577.249C104.946 576.562 105.884 575.669 106.623 574.62C107.362 573.57 107.887 572.386 108.168 571.134C108.449 569.882 108.481 568.587 108.261 567.322C108.042 566.058 107.576 564.849 106.889 563.765C106.202 562.681 105.309 561.743 104.26 561.004C103.211 560.265 102.026 559.74 100.774 559.459L98.6335 568.993L96.4929 578.528Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6099 596.823C79.492 597.755 80.549 598.504 81.7206 599.027C82.8922 599.551 84.1554 599.838 85.4382 599.874C86.721 599.909 87.9981 599.692 89.1968 599.233C90.3954 598.775 91.4921 598.085 92.4241 597.203C93.3561 596.321 94.1053 595.264 94.6289 594.092C95.1524 592.921 95.4401 591.658 95.4754 590.375C95.5107 589.092 95.2931 587.815 94.8348 586.616C94.3766 585.418 93.6868 584.321 92.8047 583.389L85.7073 590.106L78.6099 596.823Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6841 551.243L91.4678 534.065C91.1824 533.385 91.8768 532.708 92.5491 533.01C92.7194 533.086 92.8581 533.219 92.942 533.386L102.074 551.553C102.565 552.529 101.396 553.496 100.529 552.83L99.006 551.661C98.8642 551.552 98.7533 551.408 98.6841 551.243Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2687 602.47C52.4015 603.746 52.7844 604.984 53.3956 606.113C54.0067 607.241 54.8341 608.238 55.8306 609.046C56.827 609.855 57.973 610.459 59.203 610.825C60.4331 611.191 61.7231 611.311 62.9994 611.178C64.2758 611.045 65.5135 610.662 66.6419 610.051C67.7702 609.44 68.7672 608.612 69.5758 607.616C70.3844 606.62 70.9888 605.474 71.3545 604.244C71.7203 603.014 71.8401 601.724 71.7073 600.447L61.988 601.459L52.2687 602.47Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.886 557.432L101.358 557.918C101.594 558.161 101.695 558.504 101.629 558.836L97.6356 578.85C97.4189 579.936 95.8744 579.959 95.6247 578.88L95.245 577.239C95.2115 577.094 95.2098 576.944 95.2399 576.799L99.1409 557.941C99.3082 557.132 100.311 556.84 100.886 557.432Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3674 581.704L93.8462 582.384C94.1365 582.796 94.0855 583.358 93.7258 583.711L78.8201 598.338C78.3375 598.812 77.537 598.699 77.2042 598.11L76.563 596.976C76.3299 596.563 76.4086 596.045 76.7538 595.72L91.8217 581.547C92.2774 581.119 93.007 581.193 93.3674 581.704Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7834 600.543L71.3998 599.695C71.7681 599.68 72.1063 599.897 72.2468 600.238C72.4783 600.799 72.0852 601.42 71.4792 601.451L49.8742 602.554C49.6992 602.563 49.525 602.526 49.3686 602.447C48.4423 601.978 48.7461 600.584 49.7834 600.543Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9448 601.162C50.8093 601.202 49.8997 602.165 50.1758 603.267C50.3197 603.842 50.5159 604.404 50.7628 604.945C51.295 606.113 52.0519 607.164 52.9904 608.04C53.929 608.915 55.0307 609.596 56.2327 610.046C57.4347 610.495 58.7134 610.703 59.9959 610.659C61.2783 610.614 62.5394 610.317 63.7071 609.785C64.8748 609.252 65.9263 608.495 66.8014 607.557C67.6766 606.618 68.3583 605.517 68.8077 604.315C69.0161 603.757 69.1727 603.183 69.2762 602.6C69.4747 601.481 68.5 600.584 67.3645 600.623L59.6547 600.893L51.9448 601.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1316 550.145C99.6132 551.174 100.856 551.633 101.762 550.947C102.234 550.589 102.674 550.188 103.075 549.749C103.941 548.802 104.611 547.693 105.049 546.486C105.486 545.28 105.681 543.999 105.623 542.717C105.565 541.435 105.256 540.177 104.712 539.015C104.168 537.853 103.4 536.809 102.453 535.944C101.505 535.078 100.397 534.407 99.1903 533.97C97.9838 533.533 96.7031 533.338 95.4211 533.396C94.9152 533.418 94.4927 533.371 94.0952 533.34C93.0218 533.254 92.5263 534.386 92.909 535.392L95.8613 543.157L99.1316 550.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8268 593.981C79.0016 594.762 78.9568 596.087 79.8929 596.73C80.381 597.066 80.8998 597.357 81.4432 597.6C82.6148 598.124 83.8781 598.411 85.1608 598.447C86.4436 598.482 87.7208 598.264 88.9194 597.806C90.1181 597.348 91.2147 596.658 92.1468 595.776C93.0788 594.894 93.828 593.837 94.3515 592.665C94.8751 591.494 95.1627 590.231 95.1981 588.948C95.2334 587.665 95.0157 586.388 94.5575 585.189C94.345 584.633 94.0826 584.099 93.7743 583.593C93.183 582.623 91.8584 582.595 91.0332 583.376L85.43 588.679L79.8268 593.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0599 575.434C95.8354 576.548 96.5618 577.656 97.6979 577.643C98.2903 577.636 98.8822 577.575 99.4662 577.46C100.725 577.213 101.924 576.72 102.992 576.01C104.061 575.3 104.98 574.386 105.695 573.321C106.411 572.256 106.91 571.06 107.163 569.802C107.417 568.544 107.42 567.249 107.173 565.989C106.926 564.73 106.433 563.532 105.723 562.463C105.012 561.394 104.099 560.476 103.033 559.76C102.539 559.428 102.017 559.143 101.474 558.907C100.431 558.455 99.3326 559.195 99.1081 560.309L97.584 567.872L96.0599 575.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.696 747.731L812.424 709.566C811.345 708.636 809.92 708.21 808.507 708.396L807.195 708.569C802.955 709.127 801.328 714.405 804.516 717.254L847.967 756.082C849.373 757.339 851.367 757.698 853.123 757.009L855.256 756.173C858.762 754.799 859.548 750.189 856.696 747.731Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.803 684.904L953.45 659.705C952.509 659.102 951.379 658.866 950.274 659.041C946.216 659.684 945.006 664.94 948.374 667.293L985.882 693.498C987.012 694.288 988.419 694.576 989.769 694.294L991.13 694.009C995.513 693.093 996.574 687.319 992.803 684.904Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.577 727.197L972.769 575.68L980.68 576.521L834.415 731.762C833.194 733.057 831.171 733.162 829.823 732.001C828.386 730.762 828.275 728.576 829.577 727.197Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.772 613.6L843.784 613.606L843.796 613.612L967.779 671.62C968.486 671.951 969.053 672.523 969.378 673.233C970.655 676.031 967.739 678.895 964.965 677.569L830.82 613.438C828.114 612.144 828.785 608.117 831.763 607.77C832.37 607.699 832.984 607.816 833.523 608.105L843.772 613.6Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.654 521.321L725.775 578.007L759.999 618.794L1021.85 543.398L1018.4 535.961L997.077 522.306C995.47 521.277 993.521 520.923 991.654 521.321Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.077 675.007L1053.14 575.007L1054.03 566.617L796.077 659.507L796.077 675.007Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.654 521.321L725.775 578.007L759.999 618.794L1021.85 543.398L1018.4 535.961L997.077 522.306C995.47 521.277 993.521 520.923 991.654 521.321Z",
    stroke: "white",
    strokeWidth: 1.45038,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.077 675.007L1053.14 575.007L1054.03 566.617L796.077 659.507L796.077 675.007Z",
    stroke: "white",
    strokeWidth: 1.45038,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.15 543.324L746.936 615.285L795.273 660.507L1054.03 566.617L1021.15 543.324Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 1.45038,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.219 624.048C778.916 622.435 779.676 620.016 781.667 619.439L790.002 617.023C791.073 616.713 792.227 617.043 792.97 617.874L811.254 638.291C812.632 639.83 812.005 642.276 810.056 642.962L800.654 646.271C799.495 646.679 798.206 646.313 797.434 645.358L780.219 624.048Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.008 576.582L706.119 579.448L705.875 579.202L705.91 579.484L705.774 579.507L705.933 579.666L709.433 607.776C709.652 609.535 710.508 611.154 711.84 612.325L790.495 681.506L790.495 681.507L790.495 681.507L790.496 681.507L790.496 681.506L800.771 677.007L800.771 660.507L800.773 660.507L800.771 660.504L800.771 660.007L800.414 660.095L729.688 578.967C728.028 577.063 725.498 576.16 723.008 576.582Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.119 579.448L705.604 579.959C705.77 580.127 706.008 580.203 706.24 580.163L706.119 579.448ZM723.008 576.582L722.887 575.867L722.887 575.867L723.008 576.582ZM705.875 579.202L706.389 578.691C706.171 578.471 705.837 578.414 705.558 578.55C705.279 578.686 705.117 578.984 705.155 579.292L705.875 579.202ZM705.91 579.484L706.031 580.199C706.414 580.134 706.677 579.779 706.629 579.394L705.91 579.484ZM705.774 579.507L705.653 578.792C705.386 578.837 705.166 579.027 705.084 579.285C705.001 579.543 705.069 579.826 705.26 580.018L705.774 579.507ZM705.933 579.666L706.652 579.576C706.632 579.417 706.56 579.269 706.447 579.155L705.933 579.666ZM709.433 607.776L710.153 607.686L709.433 607.776ZM711.84 612.325L712.319 611.78L711.84 612.325ZM790.495 681.506L791.216 681.431C791.197 681.25 791.111 681.082 790.974 680.961L790.495 681.506ZM790.495 681.507L789.774 681.582C789.798 681.812 789.93 682.017 790.13 682.134C790.33 682.25 790.574 682.264 790.786 682.171L790.495 681.507ZM790.495 681.507L790.978 680.965C790.766 680.776 790.464 680.729 790.204 680.842L790.495 681.507ZM790.496 681.507L790.014 682.049C790.228 682.239 790.533 682.286 790.794 682.168C791.055 682.05 791.222 681.79 791.221 681.504L790.496 681.507ZM790.496 681.506L790.205 680.842C789.94 680.958 789.769 681.22 789.771 681.51L790.496 681.506ZM800.771 677.007L801.062 677.671C801.326 677.555 801.496 677.295 801.496 677.007L800.771 677.007ZM800.771 660.507L800.512 659.83C800.231 659.938 800.046 660.207 800.046 660.507L800.771 660.507ZM800.773 660.507L801.033 661.184C801.254 661.099 801.42 660.912 801.477 660.682C801.534 660.452 801.476 660.209 801.32 660.03L800.773 660.507ZM800.771 660.504L800.046 660.504C800.046 660.679 800.109 660.849 800.224 660.981L800.771 660.504ZM800.771 660.007L801.496 660.007C801.496 659.784 801.394 659.574 801.219 659.436C801.043 659.299 800.814 659.249 800.598 659.303L800.771 660.007ZM800.414 660.095L799.868 660.571C800.046 660.776 800.324 660.864 800.587 660.799L800.414 660.095ZM729.688 578.967L729.141 579.443L729.688 578.967ZM706.24 580.163L723.129 577.297L722.887 575.867L705.998 578.733L706.24 580.163ZM705.36 579.713L705.604 579.959L706.634 578.937L706.389 578.691L705.36 579.713ZM706.629 579.394L706.594 579.113L705.155 579.292L705.19 579.573L706.629 579.394ZM705.895 580.222L706.031 580.199L705.789 578.769L705.653 578.792L705.895 580.222ZM706.447 579.155L706.288 578.995L705.26 580.018L705.418 580.177L706.447 579.155ZM710.153 607.686L706.652 579.576L705.213 579.756L708.713 607.865L710.153 607.686ZM712.319 611.78C711.121 610.726 710.35 609.27 710.153 607.686L708.713 607.865C708.954 609.801 709.896 611.581 711.361 612.869L712.319 611.78ZM790.974 680.961L712.319 611.78L711.361 612.869L790.016 682.051L790.974 680.961ZM789.774 681.581L789.774 681.582L791.216 681.432L791.216 681.431L789.774 681.581ZM790.786 682.171L790.787 682.171L790.204 680.842L790.204 680.843L790.786 682.171ZM790.978 680.965L790.978 680.965L790.013 682.048L790.014 682.049L790.978 680.965ZM789.771 681.51L789.771 681.51L791.221 681.504L791.221 681.503L789.771 681.51ZM790.787 682.171L801.062 677.671L800.48 676.342L790.205 680.842L790.787 682.171ZM801.496 677.007L801.496 660.507L800.046 660.507L800.046 677.007L801.496 677.007ZM800.514 659.829L800.512 659.83L801.031 661.185L801.033 661.184L800.514 659.829ZM800.224 660.981L800.226 660.983L801.32 660.03L801.318 660.028L800.224 660.981ZM801.496 660.504L801.496 660.007L800.046 660.007L800.046 660.504L801.496 660.504ZM800.598 659.303L800.241 659.391L800.587 660.799L800.945 660.711L800.598 659.303ZM729.141 579.443L799.868 660.571L800.961 659.618L730.234 578.49L729.141 579.443ZM723.129 577.297C725.37 576.917 727.647 577.73 729.141 579.443L730.234 578.49C728.409 576.396 725.625 575.403 722.887 575.867L723.129 577.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.425 535.496L960.279 533.755C959.648 533.406 958.909 533.305 958.208 533.47L876.68 552.73C874.399 553.269 873.665 556.15 875.411 557.713L879.387 561.276C880.112 561.925 881.114 562.168 882.056 561.922L962.754 540.84C965.288 540.179 965.717 536.763 963.425 535.496Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.82 569.007L1013.01 546.701L789.673 605.686L828.273 648.007L828.273 655.507L1043.82 574.007L1043.82 569.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.828 628.092L799.211 602.711C797.772 601.286 798.403 598.839 800.351 598.286C801.26 598.029 802.237 598.275 802.915 598.933L828.797 624.043C830.289 625.491 829.768 627.998 827.823 628.731C826.785 629.122 825.615 628.872 824.828 628.092Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.812 604.71L870.564 585.738C869.054 584.39 869.62 581.907 871.565 581.346C872.404 581.104 873.308 581.303 873.967 581.876L895.465 600.565C897.039 601.933 896.586 604.487 894.637 605.231C893.672 605.599 892.583 605.398 891.812 604.71Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.209 583.738L936.17 568.764C934.671 567.644 935.038 565.31 936.804 564.732C937.528 564.494 938.327 564.633 938.934 565.102L958.738 580.388C960.062 581.41 959.745 583.484 958.179 584.04C957.516 584.275 956.776 584.162 956.209 583.738Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.63 564.036L995.437 552.685C994.001 551.612 994.294 549.387 995.954 548.747C996.695 548.462 997.534 548.587 998.165 549.076L1013.16 560.683C1014.48 561.708 1014.17 563.783 1012.6 564.338C1011.93 564.574 1011.19 564.46 1010.63 564.036Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.981 618.868L830.225 595.822C828.771 594.411 829.387 591.956 831.334 591.399C832.23 591.142 833.195 591.378 833.871 592.02L857.889 614.795C859.398 616.226 858.893 618.743 856.948 619.481C855.924 619.87 854.768 619.631 853.981 618.868Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.785 595.762L897.906 577.574C896.549 576.392 896.998 574.178 898.711 573.606C899.506 573.34 900.382 573.52 901.004 574.078L921.613 592.571C922.807 593.643 922.42 595.605 920.906 596.155C920.179 596.419 919.367 596.268 918.785 595.762Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.405 575.066L962.126 561.898C960.703 560.814 961.061 558.587 962.749 558.024C963.459 557.787 964.243 557.925 964.833 558.392L981.885 571.854C983.141 572.846 982.83 574.826 981.332 575.366C980.683 575.6 979.957 575.487 979.405 575.066Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.088 624.348L811.109 599.727C809.667 598.306 810.294 595.857 812.242 595.304C813.147 595.047 814.121 595.291 814.798 595.944L840.041 620.295C841.537 621.738 841.019 624.249 839.073 624.982C838.04 625.371 836.874 625.124 836.088 624.348Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.373 601.068L881.492 583.122C879.971 581.815 880.51 579.342 882.437 578.786C883.268 578.546 884.163 578.749 884.81 579.323L905.408 597.592C906.749 598.781 906.281 600.979 904.572 601.518C903.81 601.759 902.978 601.589 902.373 601.068Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.909 580.358L945.486 565.466C943.999 564.326 944.38 561.997 946.149 561.417C946.89 561.174 947.706 561.321 948.321 561.809L967.502 577.013C968.815 578.054 968.484 580.123 966.917 580.679C966.239 580.919 965.483 580.798 964.909 580.358Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.8 560.631L1005.11 550.142C1003.62 548.995 1003.98 546.653 1005.75 546.043C1006.52 545.778 1007.37 545.929 1008.01 546.442L1021.43 557.27C1022.74 558.325 1022.4 560.396 1020.82 560.954C1020.14 561.196 1019.38 561.074 1018.8 560.631Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.502 615.586L839.759 592.429C838.32 591.025 838.962 588.589 840.906 588.076C841.772 587.848 842.695 588.084 843.345 588.7L867.411 611.522C868.919 612.952 868.414 615.467 866.471 616.204C865.445 616.593 864.287 616.352 863.502 615.586Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.863 592.526L906.97 574.901C905.599 573.745 906.03 571.529 907.737 570.959C908.519 570.697 909.38 570.873 909.994 571.42L930.41 589.594C931.466 590.535 931.183 592.258 929.88 592.821C929.205 593.113 928.424 592.998 927.863 592.526Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.726 571.823L971.072 559.26C969.645 558.184 969.998 555.955 971.685 555.393C972.389 555.158 973.166 555.293 973.754 555.753L990.184 568.608C991.445 569.594 991.137 571.575 989.64 572.115C988.996 572.348 988.275 572.238 987.726 571.823Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.072 611.996L850.654 590.062C849.187 588.687 849.778 586.238 851.711 585.685C852.599 585.43 853.554 585.668 854.219 586.309L877.322 608.575C878.613 609.818 878.101 611.989 876.391 612.525C875.579 612.78 874.693 612.578 874.072 611.996Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.625 589.089L915.924 571.662C914.576 570.469 915.033 568.26 916.746 567.688C917.551 567.418 918.437 567.605 919.063 568.176L938.491 585.906C939.676 586.987 939.282 588.945 937.768 589.494C937.032 589.762 936.209 589.606 935.625 589.089Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.671 568.595L980.018 556.033C978.59 554.956 978.943 552.727 980.63 552.165C981.334 551.93 982.112 552.066 982.699 552.525L999.129 565.38C1000.39 566.366 1000.08 568.348 998.586 568.888C997.941 569.12 997.221 569.01 996.671 568.595Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5310_24142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828 648L1052.27 566.507",
    stroke: "#1E1E1E",
    strokeWidth: 1.45038,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.658 232.921L144.607 225.197C143.846 224.564 142.044 222.968 140.916 221.65C140.103 220.702 139.94 220.216 139.762 219.684C139.63 219.292 139.49 218.875 139.077 218.231C138.102 216.711 122.307 197.928 120.676 197.042C119.422 196.36 119.286 196.634 118.891 197.43C118.772 197.669 118.63 197.956 118.428 198.277C117.726 199.392 115.391 199.526 114.412 199.104C113.502 199.526 109.483 202.725 106.244 206.068C103.004 209.412 106.482 215.246 108.33 216.471C114.633 220.777 127.04 229.755 128.256 230.768C129.084 231.458 129.886 231.277 130.796 231.071C131.556 230.899 132.393 230.71 133.384 230.999C134.878 231.433 135.323 232.288 135.556 232.736L135.556 232.736C135.594 232.81 135.627 232.873 135.658 232.921ZM116.606 212.398C116.411 212.259 116.214 212.114 116.016 211.969C114.63 210.951 113.224 209.92 112.363 210.751C111.151 211.92 112.725 213.197 113.572 213.885C113.642 213.943 113.708 213.996 113.767 214.045C113.908 214.162 116.336 216.023 119.18 218.202L119.18 218.202C123.194 221.277 128.035 224.985 128.433 225.317C129.193 225.95 130.972 227.025 131.916 226.33C133.119 225.444 131.598 224.177 130.838 223.544C130.077 222.911 118.562 213.791 116.606 212.398ZM120.877 207.379C121.075 207.524 121.272 207.669 121.467 207.808C123.423 209.201 134.938 218.321 135.698 218.954C136.459 219.587 137.979 220.854 136.777 221.74C135.833 222.435 134.054 221.36 133.294 220.727C132.896 220.395 128.055 216.687 124.041 213.612C121.197 211.433 118.768 209.572 118.627 209.455C118.569 209.406 118.503 209.353 118.433 209.295C117.585 208.607 116.012 207.33 117.223 206.161C118.085 205.33 119.491 206.361 120.877 207.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.526 290.403C184.538 288.605 185.061 283.342 185.447 280.935C221.444 295.185 212.545 280.318 220.106 275.433C226.154 271.525 230.109 271.889 231.331 272.559L220.533 290.197L196.736 290.831C219.678 321.275 269.975 379.295 263.877 383.091C248.883 392.425 236.256 388.751 224.698 383.028C213.139 377.304 209.015 367.131 207.518 354.417C206.022 341.703 202.935 336.082 199.831 333.763C196.728 331.443 194.48 332.678 190.688 331.103C186.895 329.527 175.282 322.371 177.213 309.237C179.145 296.103 186.761 292.652 185.526 290.403Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 0.906929
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.584 317.993C177.554 308.392 187.143 295.125 192.943 289.256C193.997 288.145 207.47 286.398 213.875 288.733C220.28 291.068 222.884 280.492 223.953 278.442C225.022 276.391 226.557 267.865 235.741 275.259C244.924 282.653 240.578 292.723 247.909 296.745C255.239 300.766 267.854 296.366 283.597 310.432C300.839 325.838 293.904 343.183 290.065 351.512C286.993 358.174 272.366 375.014 265.128 382.038C259.314 386.329 244.882 392.867 230.682 381.935C212.933 368.271 219.987 339.154 206.758 331.055C197.939 325.656 190.735 326.394 184.584 317.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.011 280.809L192.943 289.256M192.943 289.256C187.143 295.125 177.554 308.392 184.584 317.993C190.735 326.394 197.939 325.656 206.758 331.055C219.987 339.154 212.933 368.271 230.682 381.935C244.882 392.867 259.314 386.329 265.128 382.038C272.366 375.014 286.993 358.174 290.065 351.512C293.904 343.183 300.839 325.838 283.597 310.432C267.854 296.366 255.239 300.766 247.909 296.745C240.578 292.723 244.924 282.653 235.741 275.259C226.557 267.865 225.022 276.391 223.953 278.442C222.884 280.492 220.28 291.068 213.875 288.733C207.47 286.398 193.997 288.145 192.943 289.256Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-206-inside-5_5310_24142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.909 231.867L145.356 223.935C144.612 223.246 142.851 221.506 141.762 220.056C140.977 219.012 140.831 218.466 140.671 217.87C140.554 217.43 140.429 216.963 140.036 216.248C139.109 214.562 123.118 198.103 121.503 197.161C120.273 196.443 120.085 196.851 119.649 197.8C119.513 198.097 119.352 198.447 119.128 198.831C118.374 200.123 116.238 199.565 115.265 199.124C114.328 199.639 111.603 201.648 108.195 205.569C104.788 209.489 107.578 213.103 109.399 214.419C115.605 219.058 128.316 228.612 129.507 229.714C130.328 230.474 130.983 230.323 131.771 230.142C132.411 229.994 133.139 229.826 134.114 230.11C135.856 230.617 136.703 231.493 136.909 231.867ZM116.559 210.069L116.559 210.069C115.197 208.968 113.816 207.853 112.912 208.83C111.64 210.203 113.182 211.591 114.012 212.338C114.081 212.4 114.145 212.458 114.203 212.511C114.341 212.639 116.724 214.655 119.514 217.015L119.515 217.016C123.455 220.348 128.205 224.366 128.595 224.726C129.339 225.415 131.096 226.565 132.078 225.74C133.329 224.687 131.84 223.309 131.096 222.621C130.352 221.932 119.063 212.036 117.139 210.532C116.947 210.382 116.753 210.225 116.559 210.069ZM121.656 204.671C121.85 204.828 122.044 204.984 122.236 205.134C124.16 206.638 135.449 216.534 136.193 217.223C136.937 217.912 138.425 219.289 137.174 220.342C136.193 221.168 134.436 220.017 133.691 219.329C133.302 218.968 128.551 214.95 124.612 211.618C121.821 209.258 119.437 207.241 119.299 207.114C119.242 207.061 119.178 207.003 119.108 206.94C118.279 206.193 116.737 204.806 118.008 203.432C118.912 202.455 120.294 203.571 121.656 204.671Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.909 231.867L145.356 223.935C144.612 223.246 142.851 221.506 141.762 220.056C140.977 219.012 140.831 218.466 140.671 217.87C140.554 217.43 140.429 216.963 140.036 216.248C139.109 214.562 123.118 198.103 121.503 197.161C120.273 196.443 120.085 196.851 119.649 197.8C119.513 198.097 119.352 198.447 119.128 198.831C118.374 200.123 116.238 199.565 115.265 199.124C114.328 199.639 111.603 201.648 108.195 205.569C104.788 209.489 107.578 213.103 109.399 214.419C115.605 219.058 128.316 228.612 129.507 229.714C130.328 230.474 130.983 230.323 131.771 230.142C132.411 229.994 133.139 229.826 134.114 230.11C135.856 230.617 136.703 231.493 136.909 231.867ZM116.559 210.069L116.559 210.069C115.197 208.968 113.816 207.853 112.912 208.83C111.64 210.203 113.182 211.591 114.012 212.338C114.081 212.4 114.145 212.458 114.203 212.511C114.341 212.639 116.724 214.655 119.514 217.015L119.515 217.016C123.455 220.348 128.205 224.366 128.595 224.726C129.339 225.415 131.096 226.565 132.078 225.74C133.329 224.687 131.84 223.309 131.096 222.621C130.352 221.932 119.063 212.036 117.139 210.532C116.947 210.382 116.753 210.225 116.559 210.069ZM121.656 204.671C121.85 204.828 122.044 204.984 122.236 205.134C124.16 206.638 135.449 216.534 136.193 217.223C136.937 217.912 138.425 219.289 137.174 220.342C136.193 221.168 134.436 220.017 133.691 219.329C133.302 218.968 128.551 214.95 124.612 211.618C121.821 209.258 119.437 207.241 119.299 207.114C119.242 207.061 119.178 207.003 119.108 206.94C118.279 206.193 116.737 204.806 118.008 203.432C118.912 202.455 120.294 203.571 121.656 204.671Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.356 223.935L146.041 224.664L146.823 223.93L146.035 223.201L145.356 223.935ZM136.909 231.867L136.033 232.349L136.653 233.479L137.594 232.596L136.909 231.867ZM141.762 220.056L142.561 219.455L142.561 219.455L141.762 220.056ZM140.671 217.87L139.706 218.128L139.706 218.128L140.671 217.87ZM140.036 216.248L139.159 216.729L139.159 216.729L140.036 216.248ZM121.503 197.161L122.007 196.297L121.503 197.161ZM119.649 197.8L120.558 198.218L119.649 197.8ZM119.128 198.831L118.264 198.328L118.264 198.328L119.128 198.831ZM115.265 199.124L115.677 198.213L115.221 198.007L114.783 198.248L115.265 199.124ZM108.195 205.569L108.95 206.225L108.195 205.569ZM109.399 214.419L109.997 213.618L109.991 213.614L109.985 213.609L109.399 214.419ZM129.507 229.714L130.186 228.98L130.186 228.98L129.507 229.714ZM131.771 230.142L131.996 231.116L131.771 230.142ZM116.559 210.069L117.239 209.335L117.214 209.312L117.188 209.291L116.559 210.069ZM116.559 210.069L115.88 210.802L115.905 210.825L115.931 210.847L116.559 210.069ZM112.912 208.83L112.178 208.15L112.178 208.15L112.912 208.83ZM114.012 212.338L113.343 213.081L113.343 213.081L114.012 212.338ZM114.203 212.511L114.882 211.777L114.882 211.777L114.203 212.511ZM119.514 217.015L118.868 217.779L118.869 217.779L119.514 217.015ZM119.515 217.016L120.161 216.252L120.161 216.252L119.515 217.016ZM128.595 224.726L129.274 223.992L128.595 224.726ZM132.078 225.74L132.722 226.505L132.722 226.505L132.078 225.74ZM117.139 210.532L116.523 211.32L116.523 211.32L117.139 210.532ZM122.236 205.134L122.852 204.347L122.852 204.347L122.236 205.134ZM121.656 204.671L121.028 205.449L121.656 204.671ZM137.174 220.342L136.531 219.577L136.531 219.577L137.174 220.342ZM133.691 219.329L134.371 218.595L134.371 218.595L133.691 219.329ZM124.612 211.618L125.258 210.855L124.612 211.618ZM119.299 207.114L118.62 207.847L118.62 207.847L119.299 207.114ZM119.108 206.94L118.439 207.684L118.439 207.684L119.108 206.94ZM118.008 203.432L117.274 202.753L117.274 202.753L118.008 203.432ZM144.671 223.206L136.224 231.139L137.594 232.596L146.041 224.664L144.671 223.206ZM140.962 220.656C142.106 222.179 143.919 223.968 144.677 224.669L146.035 223.201C145.304 222.525 143.596 220.833 142.561 219.455L140.962 220.656ZM139.706 218.128C139.785 218.427 139.88 218.784 140.071 219.207C140.263 219.631 140.537 220.091 140.962 220.656L142.561 219.455C142.202 218.977 142.011 218.642 141.893 218.383C141.776 218.123 141.717 217.909 141.637 217.611L139.706 218.128ZM139.159 216.729C139.495 217.341 139.596 217.718 139.706 218.128L141.637 217.611C141.512 217.142 141.362 216.585 140.912 215.766L139.159 216.729ZM120.999 198.025C120.999 198.025 121.027 198.042 121.092 198.091C121.152 198.137 121.229 198.199 121.325 198.278C121.515 198.438 121.758 198.653 122.05 198.92C122.632 199.453 123.384 200.171 124.251 201.019C125.983 202.713 128.156 204.904 130.31 207.122C132.464 209.34 134.594 211.578 136.241 213.364C137.065 214.258 137.764 215.034 138.282 215.635C138.542 215.937 138.752 216.188 138.908 216.385C138.986 216.484 139.046 216.565 139.091 216.628C139.114 216.659 139.131 216.684 139.143 216.703C139.155 216.722 139.16 216.73 139.159 216.729L140.912 215.766C140.735 215.444 140.303 214.915 139.797 214.329C139.257 213.704 138.542 212.91 137.711 212.009C136.049 210.206 133.906 207.954 131.745 205.729C129.583 203.503 127.398 201.298 125.649 199.589C124.775 198.734 124.005 197.999 123.4 197.445C123.098 197.168 122.831 196.931 122.609 196.746C122.404 196.573 122.189 196.403 122.007 196.297L120.999 198.025ZM120.558 198.218C120.614 198.096 120.659 197.998 120.702 197.911C120.744 197.824 120.777 197.763 120.803 197.721C120.863 197.623 120.847 197.688 120.735 197.745C120.674 197.777 120.612 197.792 120.561 197.795C120.515 197.798 120.498 197.791 120.52 197.796C120.578 197.811 120.722 197.863 120.999 198.025L122.007 196.297C121.668 196.1 121.328 195.934 120.991 195.853C120.631 195.765 120.219 195.762 119.822 195.966C119.454 196.154 119.233 196.454 119.097 196.678C118.961 196.899 118.841 197.164 118.741 197.383L120.558 198.218ZM119.992 199.335C120.243 198.904 120.422 198.514 120.558 198.218L118.741 197.383C118.604 197.68 118.461 197.99 118.264 198.328L119.992 199.335ZM114.852 200.035C115.417 200.291 116.321 200.586 117.235 200.627C118.122 200.666 119.334 200.463 119.992 199.335L118.264 198.328C118.168 198.491 117.935 198.656 117.323 198.629C116.737 198.603 116.086 198.398 115.677 198.213L114.852 200.035ZM108.95 206.225C112.312 202.356 114.949 200.439 115.746 200.001L114.783 198.248C113.707 198.839 110.893 200.94 107.441 204.913L108.95 206.225ZM109.985 213.609C109.195 213.038 108.206 211.966 107.789 210.665C107.397 209.443 107.474 207.923 108.95 206.225L107.441 204.913C105.51 207.134 105.277 209.381 105.884 211.275C106.466 213.091 107.782 214.484 108.813 215.23L109.985 213.609ZM130.186 228.98C129.543 228.385 126.006 225.676 121.937 222.596C117.833 219.488 113.102 215.939 109.997 213.618L108.8 215.22C111.902 217.539 116.63 221.086 120.73 224.19C124.867 227.322 128.28 229.941 128.828 230.448L130.186 228.98ZM131.546 229.167C131.119 229.266 130.921 229.302 130.746 229.285C130.63 229.275 130.46 229.234 130.186 228.98L128.828 230.448C129.375 230.954 129.943 231.218 130.557 231.277C131.112 231.329 131.635 231.199 131.996 231.116L131.546 229.167ZM134.394 229.15C133.153 228.789 132.206 229.015 131.546 229.167L131.996 231.116C132.616 230.973 133.124 230.863 133.835 231.07L134.394 229.15ZM137.786 231.386C137.42 230.72 136.317 229.709 134.394 229.15L133.835 231.07C134.599 231.292 135.142 231.588 135.502 231.849C135.682 231.979 135.815 232.099 135.905 232.195C136.001 232.295 136.034 232.352 136.033 232.349L137.786 231.386ZM115.88 210.802L115.88 210.802L117.239 209.335L117.239 209.335L115.88 210.802ZM113.645 209.509C113.702 209.448 113.718 209.455 113.727 209.455C113.776 209.452 113.903 209.465 114.14 209.576C114.634 209.807 115.217 210.27 115.931 210.847L117.188 209.291C116.539 208.767 115.75 208.121 114.988 207.765C114.596 207.581 114.123 207.429 113.615 207.458C113.069 207.489 112.573 207.723 112.178 208.15L113.645 209.509ZM114.681 211.595C114.24 211.198 113.787 210.777 113.554 210.344C113.447 210.146 113.423 210.008 113.428 209.916C113.433 209.841 113.461 209.708 113.645 209.509L112.178 208.15C111.726 208.638 111.47 209.193 111.432 209.789C111.396 210.366 111.57 210.88 111.794 211.294C112.221 212.085 112.954 212.732 113.343 213.081L114.681 211.595ZM114.882 211.777C114.819 211.719 114.749 211.656 114.681 211.595L113.343 213.081C113.413 213.145 113.472 213.198 113.523 213.245L114.882 211.777ZM120.16 216.251C118.765 215.071 117.472 213.978 116.51 213.163C116.029 212.756 115.632 212.419 115.347 212.176C115.204 212.054 115.09 211.957 115.007 211.886C114.916 211.808 114.882 211.777 114.882 211.777L113.523 213.245C113.683 213.393 116.099 215.436 118.868 217.779L120.16 216.251ZM120.161 216.252L120.16 216.251L118.869 217.779L118.87 217.78L120.161 216.252ZM129.274 223.992C128.862 223.612 124.08 219.567 120.161 216.252L118.87 217.779C122.829 221.128 127.548 225.12 127.916 225.46L129.274 223.992ZM131.434 224.974C131.395 225.007 131.203 225.113 130.629 224.877C130.111 224.663 129.584 224.279 129.274 223.992L127.916 225.46C128.35 225.862 129.073 226.398 129.866 226.725C130.602 227.029 131.779 227.298 132.722 226.505L131.434 224.974ZM130.417 223.355C130.815 223.723 131.242 224.131 131.459 224.525C131.56 224.709 131.562 224.8 131.561 224.819C131.56 224.824 131.559 224.831 131.551 224.846C131.541 224.864 131.512 224.909 131.434 224.974L132.722 226.505C133.205 226.098 133.502 225.582 133.553 224.991C133.601 224.434 133.419 223.94 133.212 223.562C132.811 222.832 132.122 222.207 131.776 221.887L130.417 223.355ZM116.523 211.32C118.415 212.799 129.681 222.673 130.417 223.355L131.776 221.887C131.024 221.191 119.711 211.273 117.755 209.744L116.523 211.32ZM115.931 210.847C116.124 211.002 116.324 211.164 116.523 211.32L117.755 209.744C117.571 209.6 117.383 209.448 117.188 209.291L115.931 210.847ZM122.852 204.347C122.667 204.202 122.48 204.051 122.284 203.893L121.028 205.449C121.221 205.605 121.421 205.766 121.62 205.922L122.852 204.347ZM136.872 216.489C136.12 215.793 124.808 205.876 122.852 204.347L121.62 205.922C123.512 207.401 134.777 217.275 135.514 217.957L136.872 216.489ZM137.818 221.107C138.302 220.7 138.599 220.184 138.65 219.593C138.698 219.037 138.516 218.542 138.308 218.165C137.907 217.435 137.218 216.809 136.872 216.489L135.514 217.957C135.912 218.325 136.339 218.733 136.555 219.127C136.657 219.312 136.659 219.402 136.657 219.422C136.657 219.427 136.656 219.433 136.648 219.449C136.638 219.466 136.608 219.511 136.531 219.577L137.818 221.107ZM133.012 220.063C133.446 220.464 134.17 221 134.962 221.328C135.699 221.632 136.876 221.9 137.818 221.107L136.531 219.577C136.492 219.609 136.299 219.716 135.726 219.479C135.208 219.265 134.681 218.882 134.371 218.595L133.012 220.063ZM123.966 212.382C127.926 215.731 132.644 219.722 133.012 220.063L134.371 218.595C133.959 218.214 129.177 214.17 125.258 210.855L123.966 212.382ZM118.62 207.847C118.78 207.995 121.196 210.039 123.966 212.382L125.258 210.855C123.862 209.674 122.569 208.58 121.607 207.766C121.126 207.358 120.729 207.021 120.443 206.778C120.3 206.656 120.186 206.559 120.104 206.488C120.013 206.41 119.978 206.38 119.979 206.38L118.62 207.847ZM118.439 207.684C118.51 207.747 118.569 207.8 118.62 207.847L119.979 206.38C119.915 206.321 119.845 206.258 119.778 206.197L118.439 207.684ZM117.274 202.753C116.823 203.241 116.567 203.796 116.529 204.391C116.492 204.969 116.667 205.482 116.89 205.896C117.317 206.687 118.051 207.334 118.439 207.684L119.778 206.197C119.336 205.8 118.884 205.379 118.65 204.946C118.543 204.748 118.519 204.61 118.525 204.518C118.53 204.444 118.558 204.31 118.742 204.111L117.274 202.753ZM122.284 203.893C121.636 203.369 120.847 202.724 120.084 202.367C119.692 202.183 119.22 202.032 118.712 202.06C118.166 202.091 117.67 202.325 117.274 202.753L118.742 204.111C118.799 204.05 118.815 204.058 118.824 204.057C118.872 204.054 119 204.067 119.236 204.178C119.731 204.41 120.314 204.872 121.028 205.449L122.284 203.893Z",
    fill: "white",
    mask: "url(#path-206-inside-5_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.088 352.626L265.159 322.588C265.392 322.338 265.746 322.241 266.075 322.336L268.042 322.909C268.691 323.097 268.913 323.904 268.452 324.398L239.001 355.941C238.518 356.457 237.657 356.248 237.465 355.569L236.878 353.492C236.792 353.187 236.871 352.858 237.088 352.626Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.911 231.868L145.358 223.936L222.553 297.869L211.786 308.904L136.911 231.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.868,
    cy: 309.767,
    r: 12.697,
    transform: "rotate(16.22 222.868 309.767)",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.033 231.251L250.688 343.895",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.537 229.145L253.192 341.79",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.928 227.146L255.301 339.51",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.537 224.933L257.475 336.861",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-215-outside-6_5310_24142",
    maskUnits: "userSpaceOnUse",
    x: 105.89,
    y: 212.304,
    width: 12.6762,
    height: 12.1331,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 105.89,
    y: 212.304,
    width: 12.6762,
    height: 12.1331
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.864 216.915C115.182 216.563 115.155 216.019 114.802 215.701C114.45 215.383 113.907 215.41 113.589 215.762L113.345 216.033C113.033 216.377 112.515 216.423 112.109 216.199C110.804 215.481 109.508 215.397 108.909 216.092C108.134 216.991 108.817 218.85 110.434 220.245C112.052 221.64 113.991 222.042 114.766 221.143C115.288 220.537 115.148 219.494 114.505 218.451C114.269 218.069 114.272 217.57 114.573 217.237L114.864 216.915Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.864 216.915C115.182 216.563 115.155 216.019 114.802 215.701C114.45 215.383 113.907 215.41 113.589 215.762L113.345 216.033C113.033 216.377 112.515 216.423 112.109 216.199C110.804 215.481 109.508 215.397 108.909 216.092C108.134 216.991 108.817 218.85 110.434 220.245C112.052 221.64 113.991 222.042 114.766 221.143C115.288 220.537 115.148 219.494 114.505 218.451C114.269 218.069 114.272 217.57 114.573 217.237L114.864 216.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.909 216.092L108.222 215.5L108.909 216.092ZM110.434 220.245L109.842 220.932L109.842 220.932L110.434 220.245ZM114.766 221.143L115.453 221.736L115.453 221.736L114.766 221.143ZM114.573 217.237L113.9 216.629L114.573 217.237ZM114.864 216.915L114.191 216.307L114.864 216.915ZM114.802 215.701L115.41 215.028L114.802 215.701ZM114.018 216.641L114.262 216.37L112.916 215.154L112.672 215.425L114.018 216.641ZM109.596 216.685C109.655 216.616 109.815 216.505 110.206 216.522C110.594 216.538 111.108 216.683 111.671 216.994L112.546 215.405C111.805 214.997 111.019 214.741 110.283 214.71C109.55 214.679 108.762 214.874 108.222 215.5L109.596 216.685ZM111.027 219.558C110.312 218.942 109.839 218.251 109.626 217.67C109.4 217.055 109.521 216.771 109.596 216.685L108.222 215.5C107.522 216.312 107.597 217.407 107.923 218.295C108.262 219.217 108.939 220.153 109.842 220.932L111.027 219.558ZM114.079 220.551C114.004 220.638 113.741 220.799 113.1 220.666C112.494 220.54 111.741 220.174 111.027 219.558L109.842 220.932C110.745 221.71 111.77 222.243 112.732 222.442C113.659 222.634 114.752 222.548 115.453 221.736L114.079 220.551ZM113.733 218.927C114.004 219.367 114.139 219.76 114.171 220.058C114.202 220.352 114.132 220.49 114.079 220.551L115.453 221.736C115.922 221.191 116.043 220.504 115.974 219.864C115.906 219.228 115.649 218.578 115.276 217.975L113.733 218.927ZM114.191 216.307L113.9 216.629L115.246 217.845L115.537 217.523L114.191 216.307ZM112.672 215.425C112.672 215.425 112.672 215.425 112.672 215.424C112.673 215.424 112.673 215.424 112.672 215.424C112.671 215.425 112.665 215.427 112.653 215.429C112.627 215.432 112.587 215.427 112.546 215.405L111.671 216.994C112.383 217.386 113.379 217.348 114.018 216.641L112.672 215.425ZM115.276 217.975C115.251 217.933 115.243 217.891 115.244 217.863C115.244 217.851 115.246 217.845 115.247 217.843C115.247 217.843 115.247 217.843 115.247 217.844C115.246 217.844 115.246 217.845 115.246 217.845L113.9 216.629C113.281 217.314 113.325 218.267 113.733 218.927L115.276 217.975ZM114.194 216.374C114.175 216.356 114.173 216.326 114.191 216.307L115.537 217.523C116.191 216.799 116.134 215.682 115.41 215.028L114.194 216.374ZM115.41 215.028C114.687 214.374 113.57 214.431 112.916 215.154L114.262 216.37C114.244 216.39 114.214 216.392 114.194 216.374L115.41 215.028Z",
    fill: "#1E1E1E",
    mask: "url(#path-215-outside-6_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.101 207.683C130.852 207.912 130.835 208.3 131.064 208.55C131.293 208.799 131.681 208.816 131.93 208.587L132.042 208.484C132.331 208.219 132.769 208.222 133.099 208.434C133.949 208.981 134.818 209.102 135.274 208.664C135.885 208.077 135.523 206.711 134.468 205.613C133.412 204.514 132.061 204.099 131.451 204.686C131.059 205.062 131.068 205.76 131.403 206.502C131.565 206.86 131.524 207.295 131.235 207.561L131.101 207.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-218-outside-7_5310_24142",
    maskUnits: "userSpaceOnUse",
    x: 112.035,
    y: 218.665,
    width: 12.1056,
    height: 11.4226,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 112.035,
    y: 218.665,
    width: 12.1056,
    height: 11.4226
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.616 222.676C120.897 222.286 120.809 221.742 120.419 221.461C120.029 221.179 119.485 221.267 119.203 221.658L118.981 221.965C118.71 222.342 118.2 222.445 117.772 222.266C116.375 221.684 115.057 221.743 114.529 222.511C113.848 223.502 114.743 225.299 116.527 226.524C118.311 227.749 120.309 227.939 120.99 226.948C121.45 226.277 121.189 225.237 120.419 224.255C120.142 223.901 120.091 223.404 120.353 223.04L120.616 222.676Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.616 222.676C120.897 222.286 120.809 221.742 120.419 221.461C120.029 221.179 119.485 221.267 119.203 221.658L118.981 221.965C118.71 222.342 118.2 222.445 117.772 222.266C116.375 221.684 115.057 221.743 114.529 222.511C113.848 223.502 114.743 225.299 116.527 226.524C118.311 227.749 120.309 227.939 120.99 226.948C121.45 226.277 121.189 225.237 120.419 224.255C120.142 223.901 120.091 223.404 120.353 223.04L120.616 222.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.529 222.511L113.782 221.997L114.529 222.511ZM116.527 226.524L117.04 225.776L117.04 225.776L116.527 226.524ZM120.99 226.948L121.737 227.461L120.99 226.948ZM120.419 224.255L121.133 223.695L120.419 224.255ZM119.717 222.496L119.939 222.188L118.468 221.127L118.246 221.435L119.717 222.496ZM115.277 223.024C115.331 222.945 115.485 222.814 115.885 222.787C116.281 222.761 116.818 222.851 117.423 223.103L118.121 221.429C117.329 221.099 116.508 220.928 115.764 220.977C115.024 221.027 114.254 221.309 113.782 221.997L115.277 223.024ZM117.04 225.776C116.251 225.234 115.696 224.589 115.416 224.025C115.119 223.43 115.208 223.125 115.277 223.024L113.782 221.997C113.17 222.888 113.365 223.977 113.792 224.834C114.234 225.722 115.019 226.588 116.013 227.271L117.04 225.776ZM120.242 226.434C120.173 226.535 119.92 226.727 119.258 226.664C118.631 226.604 117.83 226.318 117.04 225.776L116.013 227.271C117.008 227.954 118.098 228.376 119.086 228.47C120.039 228.56 121.126 228.351 121.737 227.461L120.242 226.434ZM119.706 224.814C120.031 225.23 120.214 225.614 120.281 225.915C120.347 226.212 120.291 226.363 120.242 226.434L121.737 227.461C122.149 226.862 122.193 226.157 122.051 225.521C121.91 224.888 121.577 224.262 121.133 223.695L119.706 224.814ZM119.88 222.146L119.618 222.51L121.089 223.571L121.351 223.207L119.88 222.146ZM118.246 221.435C118.245 221.435 118.246 221.435 118.246 221.434C118.247 221.434 118.247 221.434 118.246 221.434C118.245 221.435 118.24 221.438 118.228 221.441C118.202 221.447 118.162 221.447 118.121 221.429L117.423 223.103C118.174 223.417 119.159 223.269 119.717 222.496L118.246 221.435ZM121.133 223.695C121.103 223.657 121.091 223.617 121.089 223.59C121.088 223.577 121.089 223.571 121.09 223.57C121.09 223.569 121.09 223.569 121.09 223.57C121.089 223.57 121.089 223.571 121.089 223.571L119.618 222.51C119.077 223.259 119.226 224.202 119.706 224.814L121.133 223.695ZM119.888 222.196C119.872 222.185 119.869 222.162 119.88 222.146L121.351 223.207C121.926 222.411 121.746 221.299 120.95 220.725L119.888 222.196ZM120.95 220.725C120.153 220.151 119.042 220.331 118.468 221.127L119.939 222.188C119.927 222.204 119.905 222.208 119.888 222.196L120.95 220.725Z",
    fill: "#1E1E1E",
    mask: "url(#path-218-outside-7_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.696 203.481C126.504 203.767 126.58 204.154 126.866 204.346C127.152 204.537 127.539 204.461 127.731 204.175L127.817 204.046C128.039 203.715 128.473 203.614 128.849 203.745C129.821 204.082 130.709 203.993 131.054 203.451C131.517 202.726 130.833 201.463 129.527 200.631C128.221 199.798 126.788 199.712 126.325 200.437C126.029 200.902 126.204 201.589 126.712 202.241C126.958 202.556 127.021 202.995 126.798 203.328L126.696 203.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-221-outside-8_5310_24142",
    maskUnits: "userSpaceOnUse",
    x: 119.256,
    y: 222.773,
    width: 12.4962,
    height: 11.5766,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 119.256,
    y: 222.773,
    width: 12.4962,
    height: 11.5766
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.786 227.556C128.11 227.24 128.116 226.721 127.8 226.397C127.484 226.073 126.965 226.066 126.641 226.383L126.42 226.598C126.088 226.922 125.568 226.935 125.175 226.689C123.986 225.944 122.774 225.795 122.168 226.415C121.376 227.224 121.914 229.035 123.37 230.46C124.826 231.886 126.649 232.385 127.441 231.576C127.969 231.036 127.905 230.049 127.37 229.028C127.161 228.63 127.195 228.132 127.517 227.818L127.786 227.556Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.786 227.556C128.11 227.24 128.116 226.721 127.8 226.397C127.484 226.073 126.965 226.066 126.641 226.383L126.42 226.598C126.088 226.922 125.568 226.935 125.175 226.689C123.986 225.944 122.774 225.795 122.168 226.415C121.376 227.224 121.914 229.035 123.37 230.46C124.826 231.886 126.649 232.385 127.441 231.576C127.969 231.036 127.905 230.049 127.37 229.028C127.161 228.63 127.195 228.132 127.517 227.818L127.786 227.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.168 226.415L122.816 227.049L122.168 226.415ZM123.37 230.46L122.736 231.109L123.37 230.46ZM127.441 231.576L126.792 230.942L127.441 231.576ZM126.42 226.598L127.053 227.247L126.42 226.598ZM127.517 227.818L128.15 228.468L127.517 227.818ZM127.786 227.556L127.152 226.907L127.786 227.556ZM126.641 226.383L126.007 225.733L126.641 226.383ZM127.053 227.247L127.274 227.032L126.007 225.733L125.787 225.948L127.053 227.247ZM122.816 227.049C122.864 227 123.006 226.907 123.363 226.942C123.717 226.978 124.185 227.138 124.693 227.457L125.657 225.92C124.977 225.494 124.244 225.208 123.543 225.138C122.845 225.068 122.078 225.21 121.519 225.781L122.816 227.049ZM124.005 229.812C123.366 229.187 122.961 228.506 122.795 227.948C122.619 227.356 122.755 227.112 122.816 227.049L121.519 225.781C120.788 226.527 120.797 227.593 121.057 228.465C121.326 229.371 121.919 230.309 122.736 231.109L124.005 229.812ZM126.792 230.942C126.731 231.004 126.49 231.145 125.894 230.982C125.333 230.828 124.644 230.438 124.005 229.812L122.736 231.109C123.553 231.908 124.503 232.481 125.415 232.731C126.292 232.971 127.358 232.958 128.089 232.211L126.792 230.942ZM126.566 229.449C126.79 229.875 126.887 230.244 126.898 230.517C126.908 230.785 126.836 230.898 126.792 230.942L128.089 232.211C128.574 231.715 128.734 231.063 128.71 230.448C128.687 229.837 128.485 229.202 128.173 228.607L126.566 229.449ZM127.152 226.907L126.884 227.169L128.15 228.468L128.419 228.206L127.152 226.907ZM125.787 225.948C125.787 225.949 125.787 225.948 125.787 225.948C125.788 225.948 125.788 225.948 125.787 225.948C125.786 225.949 125.78 225.951 125.767 225.952C125.739 225.953 125.698 225.946 125.657 225.92L124.693 227.457C125.377 227.886 126.371 227.913 127.053 227.247L125.787 225.948ZM128.173 228.607C128.149 228.561 128.143 228.516 128.146 228.487C128.148 228.474 128.15 228.468 128.151 228.467C128.151 228.466 128.151 228.466 128.151 228.467C128.151 228.467 128.15 228.468 128.15 228.468L126.884 227.169C126.221 227.816 126.209 228.767 126.566 229.449L128.173 228.607ZM127.151 227.03C127.117 226.996 127.118 226.941 127.152 226.907L128.419 228.206C129.102 227.54 129.115 226.446 128.449 225.764L127.151 227.03ZM128.449 225.764C127.783 225.081 126.69 225.067 126.007 225.733L127.274 227.032C127.239 227.065 127.184 227.065 127.151 227.03L128.449 225.764Z",
    fill: "#1E1E1E",
    mask: "url(#path-221-outside-8_5310_24142)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.24 213.33C135.948 213.555 135.893 213.974 136.118 214.267C136.343 214.559 136.762 214.613 137.055 214.388L137.187 214.287C137.525 214.026 138.001 214.071 138.339 214.333C139.211 215.006 140.142 215.219 140.678 214.787C141.396 214.208 141.132 212.691 140.09 211.4C139.048 210.108 137.621 209.531 136.904 210.11C136.443 210.482 136.387 211.239 136.68 212.075C136.823 212.48 136.737 212.948 136.397 213.209L136.24 213.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.335 232.538L134.925 232.883L135.298 233.268L191.205 291.091L191.572 291.471L191.931 291.083L193.309 289.595L193.632 289.246L193.3 288.906L137.266 231.518L136.941 231.186L136.586 231.485L135.335 232.538Z",
    fill: "#1E1E1E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_5310_24142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.026 798H585.194C585.997 798 586.5 797.131 586.099 796.435L171.514 75.9572C171.215 75.4374 170.541 75.2757 170.038 75.6033L138.479 96.1873C138.181 96.3821 138.002 96.7158 138.006 97.0724L144.982 796.966C144.988 797.539 145.453 798 146.026 798Z",
    fill: "url(#paint3_linear_5310_24142)",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5310_24142",
    x: 372.656,
    y: 61.6742,
    width: 486.653,
    height: 718.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5310_24142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5310_24142",
    x: 360.255,
    y: 70.0563,
    width: 503.552,
    height: 701.887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5310_24142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5310_24142",
    x: 445.589,
    y: 70.7623,
    width: 625.8,
    height: 721.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5310_24142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5310_24142",
    x: 821.474,
    y: 565.781,
    width: 237.326,
    height: 94.547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.80153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.90076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5310_24142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5310_24142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5310_24142",
    x: 127.562,
    y: 64.9897,
    width: 469.122,
    height: 743.454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5310_24142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5310_24142",
    x1: 415.924,
    y1: 40.7359,
    x2: 534.137,
    y2: 493.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5310_24142",
    x1: 752.5,
    y1: 81,
    x2: 556.473,
    y2: 416.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835344,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5310_24142",
    x1: 1050,
    y1: 81,
    x2: 683.251,
    y2: 410.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696714,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5310_24142",
    x1: 139.998,
    y1: 36.5,
    x2: 175.919,
    y2: 448.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5310_24142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicBandContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MusicBandContrast.c654d01cc25a391aee97b43e664a66b4.svg";